/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Grid,
  Box,
  Snackbar,
  List,
  ListItem,
  ListItemText,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  alpha,
  Dialog,
  Slide,
  Divider,
  InputAdornment,
  Collapse,
  LinearProgress,
  Tooltip,
  Card,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TimelineIcon from "@mui/icons-material/Timeline";
import type { TransitionProps } from "@mui/material/transitions";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Stack } from "@mui/system";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageContainer } from "../../components/container/PageContainer";
import {
  ALLOWED_MODULES,
  LoadState,
  MODULE_NAMES,
} from "../../constants/enums";
import {
  type ILead,
  type IMultipleEvent,
  type IAdditionalContactNumber,
  initialLead,
} from "../../redux/leads/leads.types";
import { useSelector } from "react-redux";
import { ActivityRoot } from "../../components/Activity/ActivityRoot";
import { StandardCard } from "../../components/Cards";
import {
  CountryCodeSelect,
  ControlledCustomSelect,
  CustomTextField,
} from "../../components/formsComponents";
import { CustomDatePicker } from "../../components/formsComponents/CustomDatePicker";
import { useDispatchWrapper } from "../../hooks";
import { BreadcrumbBar } from "../../components/breadcrumb";
import type { IBreadcrumbItem } from "../../components/breadcrumb/BreadcrumbBar.types";
import { TopbarHeight } from "../../assets/global/Theme-variable";
import type { IStoreState } from "../../redux/initialStoreState";
import {
  clearLead,
  fetchDriveStatusListAsync,
  fetchLeadAsync,
  fetchVenueAvailabilityAsync,
  upsertLeadAsync,
} from "../../redux/leads/leadsActions";
import {
  closeLoaderWithMessage,
  openLoaderWithMessage,
  showMessage,
} from "../../redux/messages/messagesActions";
import { RoleBasedCustomButton } from "../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { useLoggedInUserInfo } from "../../hooks/useLoggedInUserInfo";
import { UsersAutoSearch } from "../../components/AutoCompleteSearches/UsersAutoSearch";
import { TabsList } from "../../components/Tabs/TabsList";
import { TabPanel } from "../../components/Tabs/TabPanel";
import { ManageRoughEstimate } from "./components/RoughEstimate/RoughEstimate";
import { useBillingCompanyContext } from "../../providers";
import { useRoles } from "../../security/RolesProvider/RolesProvider";
import { LeadPaymentDetailsList } from "./components/PaymentDetails/LeadPaymentDetailsList";
import { PaymentDetailsDialog } from "./components/PaymentDetails/PaymentDetailsDialog";
import { PreviewBeforeSaveDialog } from "./components/PreviewBeforeSaveDialog";
import { IBooking } from "../../redux/booking/booking.types";
import { BookedVenueDialog } from "./components/BookedVenueDialog";
import { IMasterStatus } from "../../redux/status/status.types";
import { initiateWorkFlow } from "../../redux/common/commonActions";
import { endPoints } from "../../constants/endPoints";
import { PhoneTextField } from "../../components/PhoneTextField/PhoneTextField";
import { UpsellAnimationButton } from "../upselling/components/UpsellAnimationButton";
import { EventDetailsManager } from "./components/ViewLeadDeatils/EventDetailsManager";
import {
  IActionItem,
  upsertActionItemAsync,
  buildChatActionItemUpsertPayload,
} from "../../redux/actionItems";
import LoadingDialog from "../../components/Dialogs/LoadingDialog";
import { LeadSourceAutoSearch, RelationAutoSearch } from "../../components/AutoCompleteSearches";
import { Add, Close, ContentCopy, Edit, Insights } from "@mui/icons-material";
import {
  getLowestOngoingStatus,
  getAvailabilityCheckKey,
  buildEventLeadPayload,
  buildEventLeadsBasePayload,
  validateEventLeads,
} from "./helpers/leadHelpers";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { CustomEmailField } from "../../components/formsComponents/CustomEmailField";
import { ChatLeadActivityDetails } from "../chatLeads/Component/ChatLeadActivityDetails";
import { CountryCodeSelector } from "../../components/CountrySelector";
import { validatePhoneNumber } from "../../constants/phoneConfig";
import { useAuth } from "../../contexts/AuthProvider";
import { api } from "../../api/api";
import {
  DialerCallButton,
  DialerCallDialog,
  useDialerCall,
} from "./components/DialerCallButton";


// Bottom-to-top slide transition for mobile dialog
const ContactSlideTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface IEventLeadsOptions {
  eventName: string;
  eventType: string;
  leadUuid: string;
  leadStatus: string;
  contactNumber: string;
  leadData: ILead;
}

interface IManageLeadProps {
  moduleUuid: string;
  isCompactMode?: boolean;
  compactModeSaveTarget?: "lead" | "actionItem";
  compactModeLeadUUID?: string;
  compactModeLeadMeUUID?: string;
  hideActivityByDefault?: boolean;
  /** Controlled Activity panel visibility — lets a host (e.g. the quick-edit
   * RightPanel) render the toggle in its own header. */
  showActivity?: boolean;
  onShowActivityChange?: (value: boolean) => void;
  chatActionItem?: IActionItem | null;
  chatLeadData?: ILead;
  leadDetails?: ILead;
  shouldUsechatLeadData?: boolean;
  isEmbeddedView?: boolean;
  onCompactModeComplete?: (data: ILead) => void;
  onCompactModeSaveClick?: () => void;
  onCompactModeCancellationClick?: () => void;
  onCompactModeSaveNoAdvanceClick?: () => void;
  onShouldShowNoAdvanceSaveChange?: (value: boolean) => void;
  setSaveDisabled?: React.Dispatch<React.SetStateAction<boolean>>;
  onCancelSuccess?: () => void;
}

/** BOOKED / CANCELLED / DEAD — save-preview payment gate & related checks. */
function isBookedCancelledOrDeadForSavePreview(
  value: string | null | undefined,
): boolean {
  const v = (value ?? "").trim();
  return v === "BOOKED" || v === "CANCELLED" || v === "DEAD";
}

function findEventForPaymentAfterSavePreview(
  previewData: ILead | null | undefined,
  serverLead: ILead | null | undefined,
): IMultipleEvent | undefined {
  return previewData?.multiple_events_list?.find((event) => {
    if (!event.leads_uuid || event.leads_uuid === "") return false;

    const initialEvent = serverLead?.multiple_events_list?.find(
      (e) => e.leads_uuid === event.leads_uuid,
    );

    const prevStatus = (initialEvent?.status ?? "").trim();
    const nextStatus = (event.status ?? "").trim();
    const prevActual = (initialEvent?.actual_status ?? "").trim();
    const nextActual = (event.actual_status ?? "").trim();

    const statusOrActualChanged =
      prevStatus !== nextStatus || prevActual !== nextActual;

    if (!statusOrActualChanged) {
      return false;
    }

    const updatedStatus = event.status ?? "";
    const updatedActual = event.actual_status ?? "";

    if (
      updatedStatus !== "" &&
      !isBookedCancelledOrDeadForSavePreview(updatedStatus)
    ) {
      return false;
    }

    return (
      isBookedCancelledOrDeadForSavePreview(updatedStatus) ||
      isBookedCancelledOrDeadForSavePreview(updatedActual)
    );
  });
}

/**
 * Same event pairing as PreviewBeforeSaveDialog `compareData` (leads_uuid lookup, else index).
 * Save (no advance): only when `actual_status` changes to BOOKED or CANCELLED vs server.
 */
function hasActualStatusChangedToBookedOrCancelled(
  formLead: ILead,
  serverLead: ILead | null | undefined,
): boolean {
  const newList = formLead.multiple_events_list ?? [];
  const oldList = serverLead?.multiple_events_list ?? [];

  for (let index = 0; index < newList.length; index++) {
    const newEvent = newList[index];
    const oldEvent = newEvent.leads_uuid
      ? oldList.find((e) => e.leads_uuid === newEvent.leads_uuid)
      : oldList[index];
    if (!oldEvent) continue;

    const prevActual = (oldEvent.actual_status ?? "").trim();
    const nextActual = (newEvent.actual_status ?? "").trim();

    if (prevActual === nextActual) continue;

    if (nextActual === "BOOKED" || nextActual === "CANCELLED") {
      return true;
    }
  }
  return false;
}

function doesFetchedLeadMatchOpenContext(
  data: ILead,
  eventLeadUuid: string | undefined,
  groupMeUuid: string | undefined,
): boolean {
  const eu = eventLeadUuid ?? "";
  const me = groupMeUuid ?? "";
  if (!eu && !me) return false;
  const dataMe = (data as { multiple_events_uuid?: string | null })
    .multiple_events_uuid;
  if (me && dataMe != null && String(dataMe) === String(me)) {
    return true;
  }
  const list = data.multiple_events_list;
  if (eu && Array.isArray(list) && list.length > 0) {
    return list.some((e) => e.leads_uuid === eu);
  }
  if (eu && data.leads_uuid === eu) {
    return true;
  }
  return false;
}

export const ManageLead: React.FC<IManageLeadProps> = (props) => {
  const {
    isCompactMode = false,
    compactModeSaveTarget = "lead",
    compactModeLeadUUID,
    hideActivityByDefault = false,
    showActivity,
    onShowActivityChange,
    chatActionItem,
    chatLeadData,
    leadDetails,
    shouldUsechatLeadData = false,
    isEmbeddedView = false,
    compactModeLeadMeUUID,
    onCompactModeComplete,
    onCompactModeSaveClick,
    onCompactModeCancellationClick,
    onCompactModeSaveNoAdvanceClick,
    setSaveDisabled,
    onCancelSuccess,
  } = props;

  const {
    uuid: urlLeadUUID,
    me_uuid,
    tab: urlTab,
  } = useParams() as {
    uuid?: string;
    me_uuid?: string;
    tab?: string;
  };

  const leadUUID = compactModeLeadUUID || urlLeadUUID;

  // A trailing "/activity" (e.g. from a notification's action_url) opens the
  // Activity panel on the Lead tab. It can land in either optional segment:
  // /manage/:uuid/activity or /manage/:uuid/:me_uuid/activity.
  const isActivityUrl = urlTab === "activity" || me_uuid === "activity";
  const routeMeUUID = me_uuid === "activity" ? undefined : me_uuid;

  const multiEventUUID = compactModeLeadMeUUID || routeMeUUID;

  const tabFromUrl = urlTab
    ? Math.max(0, ["lead", "estimate", "payment", "food"].indexOf(urlTab))
    : 0;

  const { country } = useAuth();
  const { name, userUuid } = useLoggedInUserInfo();
  const { roles } = useRoles();
  const companyOutlet = useBillingCompanyContext();
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const { dialerState, initiateCall, closeDialog } = useDialerCall();

  const accessibleModuleIds = roles
    .filter((module) => module.show_module === 1)
    .map((module) => module.module_key);

  const BCrumb: IBreadcrumbItem[] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/event-leads",
      title: "enquiry",
    },
  ];

  const leadBreadcrumbTitle = leadUUID ? "Edit Lead" : "Create Lead";

  const {
    data: requestedLeadData,
    loading: leadLoading,
    error,
  } = useSelector((storeState: IStoreState) => storeState.leads.lead);

  const { list: driveStatusList, loading: driveStatusLoading } = useSelector(
    (storeState: IStoreState) => storeState.leads.driveStatusList,
  );

  const [openCancellation, setOpenCancellation] =
    React.useState<boolean>(false);
  const [openPaymentTransaction, setOpenPaymentTransaction] =
    React.useState<boolean>(false);
  const isAdvance = true;
  const [previewBeforeSave, setPreviewBeforeSave] =
    React.useState<ILead | null>(null);
  // const [isVenueAvailable, setIsVenueAvailable] = React.useState<{
  //   checked: boolean;
  //   checked_index: number;
  //   availabilty: boolean | null;
  //   details: IBooking | null;
  // }>({
  //   checked: false,
  //   checked_index: -1,
  //   availabilty: null,
  //   details: null,
  // });

  const [venueAvailabilityMap, setVenueAvailabilityMap] = React.useState<{
    [eventIndex: number]: {
      checked: boolean;
      availabilty: boolean | null;
      details: IBooking | null;
    };
  }>({});

  const [showOptionalDetails, setShowOptionalDetails] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  const [tab, setTab] = React.useState(tabFromUrl);
  const [internalShowActivityRoot, setInternalShowActivityRoot] = useState(
    isCompactMode ? !hideActivityByDefault : false,
  );
  const showActivityRoot =
    showActivity !== undefined ? showActivity : internalShowActivityRoot;
  const setShowActivityRoot = (value: boolean) => {
    if (showActivity === undefined) setInternalShowActivityRoot(value);
    onShowActivityChange?.(value);
  };

  /* Measured height of the sticky breadcrumb bar. Fed by BreadcrumbBar's
     onHeightChange so the Activity panel can anchor exactly below it (same
     approach as ManageChatLead). */
  const [breadcrumbHeight, setBreadcrumbHeight] = React.useState(52);

  /* Activity panel anchoring (mirrors ManageChatLead) ─────────────────────
     The Activity panel is sticky and must start just below the sticky
     breadcrumb bar and span down to the viewport bottom. We derive its top
     offset from the fixed topbar + the measured breadcrumb height + the bar's
     bottom margin + a small gap, and its height from the remaining viewport. */
  const TOP_GAP = 2;
  const BREADCRUMB_MB = 8; // BreadcrumbBar's mb: 1 = 8px
  const BOTTOM_GAP = 16;
  /* The breadcrumb bar is only rendered in the normal (non-compact, non-embedded)
     view. When it's hidden, fall back to a small fixed offset so the panel isn't
     pushed down by a phantom bar height. */
  const showBreadcrumbBar = !isCompactMode && !isEmbeddedView;
  const activityTop = showBreadcrumbBar
    ? TopbarHeight + breadcrumbHeight + BREADCRUMB_MB + TOP_GAP
    : 10;

  /* When the Activity panel is open the form column shrinks (md 12 → 8.5), so
     the field grid has far less horizontal room. MUI breakpoints react to the
     viewport, not the container, so without this the `lg` sizes tuned for the
     full-width form make fields too narrow (clipped values, uneven wrapping).
     Bump each field's `lg` span when narrow so ~3 fields sit per row instead
     of 6, keeping them comfortably sized — matching the closed-panel look. */
  const isFormNarrow = Boolean(
    showActivityRoot && tab === 0 && (leadUUID || chatActionItem),
  );
  const [isDynamicFormValid, setIsDynamicFormValid] = React.useState(true);
  const [dynamicFormErrors, setDynamicFormErrors] = React.useState<string[]>(
    [],
  );
  const [showDynamicFormErrors, setShowDynamicFormErrors] =
    React.useState(false);
  const [clickedEventLeadUuid, setClickedEventLeadUuid] = React.useState("");
  const [paymentDetailsLeadUuid, setPaymentDetailsLeadUuid] =
    React.useState("");
  const [submitAttempted, setSubmitAttempted] = React.useState(false);
  const [isNoAdvanceSave, setIsNoAdvanceSave] = React.useState(false);
  const [pendingLeadSaveAfterPayment, setPendingLeadSaveAfterPayment] =
    React.useState<ILead | null>(null);
  const [showError, setShowError] = React.useState<any>(null);
  const [bookedStatusLoading, setBookedStatusLoading] = React.useState(false);
  const [isLoadingMoreEvents, setIsLoadingMoreEvents] = React.useState(false);
  const [showDescriptionField, setShowDescriptionField] = React.useState(false);
  const [chatLeadPriority, setChatLeadPriority] = React.useState<
    "HOT" | "COLD"
  >(((chatActionItem?.priority as any) ?? "") as any);
  const [contactEditDialogOpen, setContactEditDialogOpen] =
    React.useState(false);
  const [editingContactIndex, setEditingContactIndex] = React.useState<
    number | null
  >(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const lastVenueCheckRef = React.useRef<Record<number, string>>({});
  const hasLoadedLeadDataRef = React.useRef<string>("");
  const hasInitializedFromLeadDetails = React.useRef<boolean>(false);
  const skipNextLeadFetchRef = React.useRef<boolean>(false);
  const activityRef = React.useRef<HTMLDivElement>(null);
  const shouldMaintainScrollRef = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (!chatActionItem) return;
    setChatLeadPriority(((chatActionItem.priority as any) ?? "") as any);
  }, [chatActionItem?.action_item_uuid]);

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    validateForm,
  } = useFormik({
    initialValues:
      chatActionItem?.action_item_uuid || shouldUsechatLeadData
        ? (chatLeadData as ILead)
        : {
          ...initialLead,
          ...(!initialLead.handled_by_employee_uuid && {
            handled_by_employee_uuid: userUuid,
            handled_by_employee: name,
          }),
          ...(!initialLead.leads_uuid && {
            country_code: country.dialCode,
            country_iso_code: country.code
          }),
        },
    validateOnChange: true,
    validate: (values: ILead) => {
      const errors: any = {};

      // ========== Form-level validation (Common fields) ==========
      if (!values.name_of_guest) {
        errors.name_of_guest = "Name of Guest is required";
      }
      const phoneValidation = validatePhoneNumber(values.country_code || country.dialCode, values.contact_number_one);
      if (!phoneValidation.isValid) {
        errors.contact_number_one = phoneValidation.error || "Invalid phone number";
      }
      if (!values.date_of_visit) {
        errors.date_of_visit = "Date of Visit is required";
      }
      if (!values.handled_by_employee) {
        errors.handled_by_employee = "Handled by Employee is required";
      }
      if (!values.remarks) {
        errors.remarks = "Remarks is required";
      }
      if (
        values.additional_contact_number?.length > 0 &&
        values.additional_contact_number.some(
          (contact) =>
            contact.contact_number && !validatePhoneNumber(contact.country_code || "+91", contact.contact_number).isValid,
        )
      ) {
        errors.additional_contact_number =
          "Alternate Contact number is invalid";
      }

      // ========== Email validation ==========
      if (values.email && values.email.trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(values.email)) {
          errors.email =
            "Please enter a valid email address (e.g., user@example.com)";
        }
      }

      // ========== Events list validation ==========
      if (
        !values.multiple_events_list ||
        values.multiple_events_list.length === 0
      ) {
        errors.multiple_events_list = "At least one event is required";
      } else {
        // Validate each event in the table (shared with the quotation "create lead" dialog)
        Object.assign(
          errors,
          validateEventLeads(values.multiple_events_list, {
            isLeadDead:
              (values.actual_status || "").toUpperCase() === "DEAD" ||
              (values.status || "").toUpperCase() === "DEAD",
          }),
        );

        // ========== Remarks validation (form-level, but depends on event status) ==========
        // Remarks required if any event has status other than BOOKED
        const hasNonBookedEvent = values.multiple_events_list.some(
          (event) => event.actual_status !== "BOOKED",
        );
        if (hasNonBookedEvent && !values.remarks) {
          errors.remarks = "Remarks is required";
        }

        // Remarks required if any event is CANCELLED or DEAD
        const hasCancelledOrDeadEvent = values.multiple_events_list.some(
          (event) => ["CANCELLED", "DEAD"].includes(event.actual_status || ""),
        );
        if (hasCancelledOrDeadEvent && !values.remarks) {
          errors.remarks = "Remarks is required for cancelled or dead events";
        }

        // Cancel followup date validation if status selected is DEAD
        const isLeadStatusDead =
          (values.multiple_events_list || []).some(
            (e) =>
              (e.actual_status || "").toUpperCase() === "DEAD" ||
              (e.status || "").toUpperCase() === "DEAD",
          ) ||
          (values.actual_status || "").toUpperCase() === "DEAD" ||
          (values.status || "").toUpperCase() === "DEAD";

        if (isLeadStatusDead) {
          Object.keys(errors).forEach((key) => {
            if (key.includes("followup_date")) {
              delete errors[key];
            }
          });
        }
      }

      return errors;
    },
    onSubmit: async (values) => {
      setSubmitAttempted(true);

      if (!isDynamicFormValid) {
        setShowDynamicFormErrors(true);
        dispatch(
          showMessage({
            type: "error",
            message: `Please fill all required fields in Additional Form Fields: ${dynamicFormErrors.join(
              ", ",
            )}`,
            displayAs: "snackbar",
          }),
        );
        return;
      }

      setLoading(true);

      const isUpdate = leadUUID ? true : false;

      const finalValues = { ...values };

      // Automatically set multiple_events based on number of events
      const eventCount = values.multiple_events_list?.length || 0;
      finalValues.multiple_events = eventCount > 1 ? 1 : 0;

      dispatch(openLoaderWithMessage("Saving, Please wait...."));

      if (
        isCompactMode &&
        compactModeSaveTarget === "actionItem" &&
        chatActionItem?.action_item_uuid
      ) {
        const chatActionItemWithPriority: IActionItem = {
          ...chatActionItem,
          priority: chatLeadPriority ? chatLeadPriority : null,
        } as IActionItem;
        dispatch(
          upsertActionItemAsync(
            buildChatActionItemUpsertPayload(
              chatActionItemWithPriority,
              finalValues,
              {
                company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
                name: finalValues.name_of_guest,
                mobile_no: finalValues.contact_number_one,
                description: finalValues.remarks,
              },
            ),
            (isSuccess) => {
              if (isSuccess) {
                if (onCompactModeComplete) {
                  onCompactModeComplete(finalValues);
                }
              }
              setLoading(false);
              dispatch(closeLoaderWithMessage());
            },
          ),
        );
        return;
      }

      const basePayload = buildEventLeadsBasePayload(
        finalValues,
        companyOutlet.comapny,
      );

      const payloadArray = generateMultipleEventsPayload(basePayload);

      // Always send array of payloads (single event will be array with one object)
      dispatch(
        upsertLeadAsync(
          payloadArray, // Always send as array
          requestedLeadData,
          isUpdate,
          false,
          (isSuccess) => {
            if (isSuccess) {
              if (clickedEventLeadUuid !== "" && !isNoAdvanceSave) {
                setOpenPaymentTransaction(true);
              } else {
                setIsNoAdvanceSave(false);
                if (chatActionItem?.action_item_uuid && onCompactModeComplete) {
                  const chatActionItemWithPriority: IActionItem = {
                    ...chatActionItem,
                    priority: chatLeadPriority ? chatLeadPriority : null,
                  } as IActionItem;
                  dispatch(
                    upsertActionItemAsync(
                      buildChatActionItemUpsertPayload(
                        chatActionItemWithPriority,
                        finalValues,
                        {
                          company_outlet_uuid:
                            companyOutlet.comapny.company_outlet_uuid,
                          forceActionItemStatus: "LEAD",
                        },
                      ),
                      (isSuccess) => {
                        if (isSuccess) {
                          onCompactModeComplete(finalValues);
                        }
                      },
                    ),
                  );
                } else if (isCompactMode && onCompactModeComplete) {
                  onCompactModeComplete(finalValues);
                } else {
                  navigate(REACT_APP_NAV_ROUTES.leads.EventLeads);
                }
              }
            }
            setLoading(false);
            dispatch(closeLoaderWithMessage());
          },
        ),
      );

      dispatch(
        initiateWorkFlow(
          initialLead,
          finalValues,
          endPoints.leads.upsertLead,
          true,
          "lead_id",
          values.lead_code,
        ),
      );
    },
  });

  useEffect(() => {
    if (isMobile && showActivityRoot && isCompactMode && activityRef.current) {
      const scrollToActivity = () => {
        requestAnimationFrame(() => {
          activityRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      };

      scrollToActivity();
      const timer1 = setTimeout(scrollToActivity, 300);
      const timer2 = setTimeout(scrollToActivity, 600);
      const timer3 = setTimeout(scrollToActivity, 1000);
      const timer4 = setTimeout(scrollToActivity, 1500);
      const timer5 = setTimeout(scrollToActivity, 2500);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
        clearTimeout(timer4);
        clearTimeout(timer5);
      };
    }
  }, [
    isMobile,
    showActivityRoot,
    isCompactMode,
    leadLoading,
    isLoadingMoreEvents,
  ]);

  useEffect(() => {
    if (
      isMobile &&
      showActivityRoot &&
      isCompactMode &&
      activityRef.current &&
      requestedLeadData &&
      shouldMaintainScrollRef.current
    ) {
      const scrollToActivity = () => {
        requestAnimationFrame(() => {
          activityRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      };
      const timer1 = setTimeout(scrollToActivity, 100);
      const timer2 = setTimeout(scrollToActivity, 500);
      const timer3 = setTimeout(scrollToActivity, 1000);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
      };
    }
  }, [isMobile, showActivityRoot, isCompactMode, requestedLeadData]);

  const disableFormByStatus =
    isLoadingMoreEvents ||
      (leadUUID &&
        requestedLeadData?.multiple_events_list?.some((item) =>
          ["CANCELLED", "DEAD", "BOOKED", "HOLD"].includes(
            item.actual_status as string,
          ),
        ))
      ? true
      : false;

  const isEventDisabled = (eventIndex: number): boolean => {
    if (isLoadingMoreEvents) return true;
    if (!leadUUID || !requestedLeadData?.multiple_events_list) return false;
    const initialEvent = requestedLeadData.multiple_events_list[eventIndex];
    if (!initialEvent) return false;

    return ["CANCELLED", "DEAD", "BOOKED", "HOLD", "POSTPONED"].includes(
      initialEvent.actual_status,
    );
  };
  const isDescriptionDisabled =
    isLoadingMoreEvents ||
    (leadUUID &&
      requestedLeadData?.multiple_events_list?.some((item) =>
        ["BOOKED", "DEAD"].includes(item.actual_status as string),
      )) ||
    (!leadUUID &&
      values?.multiple_events_list?.some((item) =>
        ["BOOKED", "DEAD"].includes(item.actual_status as string),
      ));

  const shouldShowNoAdvanceSave = React.useMemo(() => {
    if (!leadUUID || !requestedLeadData) {
      return false;
    }

    return hasActualStatusChangedToBookedOrCancelled(values, requestedLeadData);
  }, [leadUUID, requestedLeadData, values.multiple_events_list]);

  const eventOptionsForPaymentDetails: IEventLeadsOptions[] = React.useMemo(
    () =>
      values?.multiple_events_list?.map((item: IMultipleEvent) => ({
        eventName: item.other_event_name || "",
        eventType: item.event_type,
        leadUuid: item.leads_uuid || "",
        leadStatus: item.actual_status || "",
        contactNumber: values.contact_number_one || "",
        leadData: item as ILead,
      })) || [],
    [values?.multiple_events_list, values.contact_number_one],
  );

  const fetchMultiEventLeadAsync = () => {
    // /manage/:multiple_events_uuid/payment (e.g. Edit from Payment Details):
    // the first segment is a multiple_events_uuid, so fetch by it and redirect
    // to the canonical /manage/:leads_uuid/:me_uuid/payment URL.
    if (!isCompactMode && me_uuid === "payment" && !urlTab) {
      dispatch(
        fetchLeadAsync({
          multiple_events_uuid: urlLeadUUID,
          company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
          onCallBack: (lead, isSuccess) => {
            if (isSuccess && lead?.leads_uuid) {
              // Lead is already in the store — don't refetch after the redirect.
              skipNextLeadFetchRef.current = true;
              navigate(
                `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${lead.leads_uuid}/${urlLeadUUID}/payment`,
                { replace: true },
              );
            }
          },
        }),
      );
      return;
    }

    dispatch(
      fetchLeadAsync({
        multiple_events_uuid: multiEventUUID,
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        skipLoader: isCompactMode ? true : false,
      }),
    );
    // setIsVenueAvailable({
    //   checked: false,
    //   availabilty: false,
    //   checked_index: -1,
    //   details: null,
    // });
    setVenueAvailabilityMap({});
  };

  // useEffect(() => {
  //   // Sync_Testing
  //   if (!setSaveDisabled) return;
  //   if (isVenueAvailable.checked) {
  //     const chagedStatus =
  //       values?.multiple_events_list?.[isVenueAvailable.checked_index]?.[
  //         "actual_status"
  //       ];
  //     const hasStatusChange = Boolean(
  //       (chagedStatus && chagedStatus === "BOOKED") || chagedStatus === "HOLD",
  //     );
  //     setSaveDisabled(hasStatusChange && !isVenueAvailable.availabilty);

  //     // values.multiple_events_list.forEach((event, index) => {
  //     //   const initialStatus = requestedLeadData?.multiple_events_list?.[index]?.["actual_status"];
  //     //   const chagedStatus = event?.actual_status
  //     //   console.log("setSaveDisabled called 1", {
  //     //     initialStatus,
  //     //     chagedStatus,
  //     //     isChanged: initialStatus !== chagedStatus,
  //     //     isVenueAvailableChecked: isVenueAvailable.checked,
  //     //     isVenueAvailableAvailabilty: isVenueAvailable.availabilty,
  //     //     disableCondition: values.actual_status === "BOOKED" && isVenueAvailable.checked && !isVenueAvailable.availabilty
  //     //   })
  //     //   if (initialStatus !== chagedStatus && chagedStatus === "BOOKED" && isVenueAvailable.checked) {
  //     //     console.log("setSaveDisabled called 2=> ", values.actual_status === "BOOKED" && isVenueAvailable.checked && !isVenueAvailable.availabilty)
  //     //     setSaveDisabled(values.actual_status === "BOOKED" && isVenueAvailable.checked && !isVenueAvailable.availabilty)
  //     //   } else {
  //     //     setSaveDisabled(false)
  //     //   }
  //     // })
  //   }
  // }, [isVenueAvailable, values]);

  useEffect(() => {
    if (!setSaveDisabled) return;

    // Check if any event with BOOKED/HOLD status has availability checked and unavailable
    const hasUnavailableVenue = values.multiple_events_list?.some(
      (event, index) => {
        const availability = venueAvailabilityMap[index];
        const isBookedOrHold =
          event.actual_status === "BOOKED" || event.actual_status === "HOLD";

        return (
          isBookedOrHold && availability?.checked && !availability?.availabilty
        );
      },
    );

    setSaveDisabled(hasUnavailableVenue);
  }, [venueAvailabilityMap, values.multiple_events_list, setSaveDisabled]);

  // Legacy: Preview onSave used to open payment when `clickedEventLeadUuid` was already set
  // (old "Make Payment" → preview). Make Payment now opens PaymentDetailsDialog directly.

  // const handleBookedStatusSave = () => {
  //   setOpenPaymentTransaction(true);
  // };

  const handleComplete = async (
    isSuccess: boolean,
    cancellationData?: {
      remarks: string;
      cancellation_dead_reason: string;
      leads_uuid: string;
    },
  ) => {
    setOpenCancellation(false);
    setOpenPaymentTransaction(false);
    if (isSuccess) {
      console.log("handleComplete_Status Step 1 ==> ");
      if (pendingLeadSaveAfterPayment) {
        setLoading(true);
        const isUpdate = leadUUID ? true : false;
        dispatch(openLoaderWithMessage("Saving, Please wait...."));

        const basePayload = {
          ...pendingLeadSaveAfterPayment,
          company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
          company_outlet_name: companyOutlet.comapny.company_outlet_name,
          event_uuid: undefined,
          event_type: undefined,
          event_time: undefined,
          event_time_uuid: undefined,
          preferred_venue: undefined,
          preferred_venue_uuid: undefined,
          status: undefined,
          actual_status: undefined,
          drive_status_uuid: undefined,
          service: undefined,
          number_of_rooms: undefined,
          number_of_guests: undefined,
          payment_mode: undefined,
          cancellation_dead_reason: undefined,
          other_event_name: undefined,
          function_month: undefined,
          function_date: undefined,
          followup_date: undefined,
        };

        const payloadArray = generateMultipleEventsPayload(basePayload);
        console.log("handleComplete_Status Step 1  2==> ");
        dispatch(
          upsertLeadAsync(
            payloadArray,
            requestedLeadData,
            isUpdate,
            false,
            (isSuccess, data) => {
              dispatch(closeLoaderWithMessage());

              if (isSuccess) {
                // dispatch(fetchMultiEventLeadAsync());
                navigate(REACT_APP_NAV_ROUTES.leads.EventLeads);
              }
              setLoading(false);
              setPendingLeadSaveAfterPayment(null);
            },
          ),
        );
        return;
      }

      if (cancellationData) {
        setLoading(true);
        const isUpdate = leadUUID ? true : false;
        dispatch(openLoaderWithMessage("Saving, Please wait...."));
        console.log("handleComplete_Status Step 2 =>  1 ==> ");
        try {
          dispatch(
            fetchDriveStatusListAsync(
              companyOutlet.comapny.company_outlet_uuid,
            ),
          );

          if (driveStatusList.length > 0) {
            const deadStatus = driveStatusList.find(
              (item: any) => item.actual_status === "DEAD",
            );
            // Create base payload for cancellation
            const basePayload = {
              ...values,
              company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
              company_outlet_name: companyOutlet.comapny.company_outlet_name,

              // Clear undefined fields
              event_uuid: undefined,
              event_type: undefined,
              event_time: undefined,
              event_time_uuid: undefined,
              preferred_venue: undefined,
              preferred_venue_uuid: undefined,
              status: undefined,
              actual_status: undefined,
              drive_status_uuid: undefined,
              service: undefined,
              number_of_rooms: undefined,
              number_of_guests: undefined,
              payment_mode: undefined,
              cancellation_dead_reason: undefined,
              other_event_name: undefined,
              function_month: undefined,
              function_date: undefined,
              followup_date: undefined,
            };

            // Generate payload array with cancellation data for the specific event
            const payloadArray = generateMultipleEventsPayloadWithCancellation(
              basePayload,
              deadStatus,
              cancellationData,
            );
            console.log("handleComplete_Status Step 2 =>  1 ==> Success");
            dispatch(
              upsertLeadAsync(
                payloadArray,
                requestedLeadData,
                isUpdate,
                false,
                (isSuccess, data) => {
                  dispatch(closeLoaderWithMessage());
                  console.log(
                    "handleComplete_Status Step 2 =>  1 ==> result Success ",
                    isSuccess,
                  );
                  if (isSuccess) {
                    if (onCancelSuccess) {
                      onCancelSuccess();
                    } else {
                      navigate(REACT_APP_NAV_ROUTES.leads.EventLeads);
                    }
                  }
                  setLoading(false);
                },
              ),
            );
          }
        } catch (error) {
          dispatch(closeLoaderWithMessage());
          dispatch(
            showMessage({
              type: "error",
              message: "Failed to fetch DEAD status. Please try again.",
              displayAs: "snackbar",
            }),
          );
          setLoading(false);
        }
      } else {
        // Plain payment save succeeded (upsertPaymentDetailAsync only). Do not upsert or refetch the lead form.
        setClickedEventLeadUuid("");
      }
    }
  };

  // Helper function to generate payload for multiple events
  const generateMultipleEventsPayload = (baseValues: any) => {
    const payloadArray = values.multiple_events_list?.map(
      (event: IMultipleEvent) => buildEventLeadPayload(baseValues, event),
    );

    return payloadArray;
  };

  // Handler for Booked button click - updates only the status to BOOKED
  const handleBookedStatusClick = async (
    leadUuid: string,
    btnType: "BOOKED" | "RELEASE_HOLD",
  ) => {
    try {
      setBookedStatusLoading(true);
      dispatch(openLoaderWithMessage("Updating status to Booked..."));

      // Find the event with the given leadUuid
      const eventLead = values.multiple_events_list?.find(
        (event) => event.leads_uuid === leadUuid,
      );

      if (!eventLead) {
        dispatch(closeLoaderWithMessage());
        dispatch(
          showMessage({
            type: "error",
            message: "Event not found",
            displayAs: "snackbar",
          }),
        );
        setBookedStatusLoading(false);
        return;
      }

      // Find the BOOKED status from driveStatusList
      const bookedStatus = driveStatusList.find((item: IMasterStatus) =>
        btnType === "BOOKED"
          ? item.actual_status === "BOOKED"
          : item.actual_status === "ONGOING",
      );

      if (!bookedStatus) {
        dispatch(closeLoaderWithMessage());
        dispatch(
          showMessage({
            type: "error",
            message: "BOOKED status not configured",
            displayAs: "snackbar",
          }),
        );
        setBookedStatusLoading(false);
        return;
      }

      // Create payload with just the status updated to BOOKED
      const bookedPayload: ILead[] = [
        {
          ...values,
          company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
          company_outlet_name: companyOutlet.comapny.company_outlet_name,
          leads_uuid: eventLead.leads_uuid,
          event_uuid: eventLead.event_uuid,
          event_type: eventLead.event_type,
          event_time: eventLead.event_time,
          event_time_uuid: eventLead.event_time_uuid,
          preferred_venue: eventLead.preferred_venue || null,
          preferred_venue_uuid: eventLead.preferred_venue_uuid || null,
          function_month: eventLead.function_month || null,
          function_date: eventLead.function_date || null,
          followup_date: eventLead.followup_date || null,
          // Update status to BOOKED
          status: bookedStatus.name,
          actual_status: bookedStatus.actual_status,
          drive_status_uuid: bookedStatus.status_uuid,
          number_of_rooms: eventLead.number_of_rooms,
          number_of_guests: eventLead.number_of_guests,
          payment_mode: eventLead.payment_mode ?? null,
          cancellation_dead_reason: eventLead.cancellation_dead_reason ?? null,
          other_event_name: eventLead.other_event_name ?? null,
          estimated_rough_revenue: eventLead.estimated_rough_revenue ?? null,
          guest_budget: eventLead.guest_budget ?? null,
          extras: eventLead.extras ?? null,
          multiple_events_list: [],
        },
      ];

      dispatch(
        upsertLeadAsync(
          bookedPayload,
          requestedLeadData,
          true, // isUpdate
          false,
          (isSuccess) => {
            dispatch(closeLoaderWithMessage());
            if (isSuccess) {
              // fetchMultiEventLeadAsync();
              // Close the right panel on success
              if (isCompactMode && onCompactModeComplete) {
                onCompactModeComplete(bookedPayload[0]);
              }

              navigate(REACT_APP_NAV_ROUTES.leads.EventLeads);
            }
            setBookedStatusLoading(false);
          },
        ),
      );
    } catch (error) {
      dispatch(closeLoaderWithMessage());
      dispatch(
        showMessage({
          type: "error",
          message: "Failed to update status",
          displayAs: "snackbar",
        }),
      );
      setBookedStatusLoading(false);
    }
  };

  const handleDeleteEventLead = async (
    eventLeadUuid: string,
    onSuccess?: (isSuccess: boolean) => void,
  ) => {
    try {
      setDeleteLoading(true);

      const eventLead = values.multiple_events_list?.find(
        (event) => event.leads_uuid === eventLeadUuid,
      );

      if (!eventLead) {
        setDeleteLoading(false);
        onSuccess?.(false);
        return;
      }

      if (!eventLeadUuid) {
        setDeleteLoading(false);
        onSuccess?.(false);
        return;
      }

      // Create base payload with common lead fields (similar to generateMultipleEventsPayload)
      const basePayload = {
        ...values,
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        company_outlet_name: companyOutlet.comapny.company_outlet_name,
        // Remove multiple_events_list from payload
        multiple_events_list: undefined,
      };

      // Create payload for the single event to be archived (similar to generateMultipleEventsPayload)
      const deletePayload = [
        {
          ...basePayload,
          // Use individual lead UUID for this event
          leads_uuid: eventLead.leads_uuid,
          // Event identification
          event_uuid: eventLead.event_uuid,
          event_type: eventLead.event_type,
          event_time: eventLead.event_time,
          event_time_uuid: eventLead.event_time_uuid,
          preferred_venue: eventLead.preferred_venue,
          preferred_venue_uuid: eventLead.preferred_venue_uuid,
          // Event-specific fields
          function_month: eventLead.function_month || null,
          function_date: eventLead.function_date || null,
          followup_date: eventLead.followup_date || null,
          // status: deadStatus.name,
          // actual_status: deadStatus.actual_status,
          // drive_status_uuid: deadStatus.status_uuid,
          service: eventLead.service,
          number_of_rooms: eventLead.number_of_rooms,
          number_of_guests: eventLead.number_of_guests,
          // Conditional fields
          payment_mode: eventLead.payment_mode || null,
          cancellation_dead_reason: eventLead.cancellation_dead_reason || null,
          other_event_name: eventLead.other_event_name || null,
          estimated_rough_revenue: eventLead.estimated_rough_revenue ?? null,
          guest_budget: eventLead.guest_budget ?? null,
          duplicate_reference_uuid: eventLead.duplicate_reference_uuid ?? null,
          duplicate_reference_contact_number: eventLead.duplicate_reference_contact_number ?? null,
          extras: eventLead.extras ?? null,
          // Archive flag
          is_archived: 1,
        },
      ];

      dispatch(
        upsertLeadAsync(
          deletePayload as any,
          requestedLeadData,
          true,
          false,
          (isSuccess) => {
            setDeleteLoading(false);
            onSuccess?.(isSuccess || false);
            if (isSuccess) {
              // Refresh the lead data
              // fetchMultiEventLeadAsync();
              navigate(REACT_APP_NAV_ROUTES.leads.EventLeads);
            }
          },
        ),
      );
    } catch (error) {
      dispatch(closeLoaderWithMessage());
      dispatch(
        showMessage({
          type: "error",
          message: "Failed to fetch DEAD status. Please try again.",
          displayAs: "snackbar",
        }),
      );
      setLoading(false);
    }
  };

  // Helper function to generate payload for multiple events with cancellation data
  const generateMultipleEventsPayloadWithCancellation = (
    baseValues: any,
    deadStatus: any,
    cancellationData: {
      remarks: string;
      cancellation_dead_reason: string;
      leads_uuid: string;
    },
  ) => {
    const payloadArray = values.multiple_events_list?.map(
      (event: IMultipleEvent) => {
        // Check if this is the event being cancelled (matches the cancellationData.leads_uuid)
        const isCancelledEvent =
          event.leads_uuid === cancellationData.leads_uuid;

        return {
          ...baseValues,
          // Use individual lead UUID for each event (not URL UUID)
          leads_uuid: event.leads_uuid,
          // Event identification
          event_uuid: event.event_uuid,
          event_type: event.event_type,
          event_time: event.event_time,
          event_time_uuid: event.event_time_uuid,
          preferred_venue: event.preferred_venue,
          preferred_venue_uuid: event.preferred_venue_uuid,
          // Event-specific fields (independent per row)
          function_month: event.function_month,
          function_date: event.function_date,
          // Send null (not "") when no follow-up date is set or status is DEAD.
          followup_date:
            (event.actual_status || "").toUpperCase() === "DEAD" ||
              (event.status || "").toUpperCase() === "DEAD"
              ? null
              : event.followup_date || null,
          service: event.service,
          number_of_rooms: event.number_of_rooms,
          number_of_guests: event.number_of_guests,
          customer_relative_name: event.customer_relative_name,
          relation_with_customer: event.relation_with_customer,
          estimated_rough_revenue: event.estimated_rough_revenue ?? null,
          guest_budget: event.guest_budget ?? null,
          // Conditional fields
          payment_mode: event.payment_mode,
          other_event_name: event.other_event_name,
          duplicate_reference_uuid: event.duplicate_reference_uuid ?? null,
          duplicate_reference_contact_number: event.duplicate_reference_contact_number ?? null,
          // Custom Title (key/value pairs) — per-event, not the lead-level extras in baseValues
          extras: event.extras ?? null,
          // Apply cancellation data only to the cancelled event
          ...(isCancelledEvent && {
            status: "DEAD",
            actual_status: deadStatus.actual_status,
            drive_status_uuid: deadStatus.status_uuid,
            cancellation_dead_reason: cancellationData.cancellation_dead_reason,
          }),

          // For non-cancelled events, keep their original status
          ...(!isCancelledEvent && {
            status: event.status,
            actual_status: event.actual_status,
            drive_status_uuid: event.drive_status_uuid,
            cancellation_dead_reason: event.cancellation_dead_reason,
          }),

          remarks: isCancelledEvent ? cancellationData.remarks : undefined,

          // Remove multiple_events_list from payload as it's not in swagger
          multiple_events_list: undefined,
        };
      },
    );

    return payloadArray;
  };

  const handlePhoneTextFieldChange = (fieldName: string) => (value: string) => {
    setFieldValue(fieldName, value);
  };


  const handleFollowupDateChange = (newValue: string | null) => {
    setValues({
      ...values,
      followup_date: newValue,
      multiple_events_list: (values.multiple_events_list || []).map(
        (event) => ({
          ...event,
          followup_date: newValue,
        }),
      ),
    });
  };

  const isDeadStatus = React.useMemo(() => {
    const list = values.multiple_events_list;
    if (list && list.length > 0) {
      return list.some(
        (event) =>
          (event.actual_status || "").toUpperCase() === "DEAD" ||
          (event.status || "").toUpperCase() === "DEAD",
      );
    }
    return (
      (values.actual_status || "").toUpperCase() === "DEAD" ||
      (values.status || "").toUpperCase() === "DEAD"
    );
  }, [values.multiple_events_list, values.actual_status, values.status]);

  const followupDateErrorMessage = submitAttempted && !isDeadStatus
    ? (values.multiple_events_list || [])
      .map(
        (_, index) => (errors as any)[`multiple_events_list_${index}_followup_date`],
      )
      .find(Boolean) || ""
    : "";

  const handleCopyPhoneNumber = async (
    phoneNumber: string,
    _countryCode?: string,
  ) => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      dispatch(
        showMessage({
          type: "success",
          displayAs: "snackbar",
          message: "Phone number copied to clipboard!",
        }),
      );
    } catch (error) {
      dispatch(
        showMessage({
          type: "error",
          displayAs: "snackbar",
          message: "Failed to copy phone number",
        }),
      );
    }
  };

  // Call button shown beside the copy button on every contact number
  const renderCallButton = (phoneNumber?: string | null, countryCode?: string | null) => (
    <DialerCallButton
      phoneNumber={`${countryCode || ""}${phoneNumber || ""}`}
      onCall={initiateCall}
      disabled={dialerState.loading || !phoneNumber}
    />
  );

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const tabNames = ["lead", "estimate", "payment", "food"];
    setTab(newValue);

    if (leadUUID && !isEmbeddedView) {
      navigate(
        `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${leadUUID}/${multiEventUUID}/${tabNames[newValue]}`,
      );
    }
  };

  const handleCancellationClose = () => {
    setOpenCancellation(false);
  };

  const handlePaymentTransactionClose = () => {
    setOpenPaymentTransaction(false);
    setClickedEventLeadUuid("");
  };

  const handleUpsellClick = async () => {
    navigate("/upsell", {
      state: {
        leadData: requestedLeadData,
      },
    });
  };
  const handleGlobalSaveClick = async () => {
    const formErrors = await validateForm();
    if (Object.keys(formErrors).length > 0) {
      setSubmitAttempted(true);
      setShowError(formErrors);
      return;
    }
    handleSubmit();
  };

  React.useEffect(() => {
    if (urlTab) {
      const newTabIndex = ["lead", "estimate", "payment", "food"].indexOf(
        urlTab,
      );
      if (newTabIndex !== -1 && newTabIndex !== tab) {
        setTab(newTabIndex);
      }
    }
  }, [urlTab, tab]);

  // Re-open on in-place navigation too (a notification clicked while this
  // page is already mounted). The panel only renders on the Lead tab.
  React.useEffect(() => {
    if (isActivityUrl && !isCompactMode) {
      setTab(0);
      setShowActivityRoot(true);
    }
  }, [isActivityUrl, leadUUID, isCompactMode]);

  React.useEffect(() => { }, [error]);

  React.useEffect(() => {
    return () => {
      dispatch(clearLead());
      hasLoadedLeadDataRef.current = "";
      lastVenueCheckRef.current = {};
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // React.useEffect(() => {
  //   if (!leadUUID) {
  //     css
  //     setFieldValue("handled_by_employee", name);
  //     setFieldValue("handled_by_employee_uuid", userUuid);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [leadUUID]);

  // Initialize form with leadDetails (row data) immediately for compact/embedded mode
  // This provides instant UI feedback while API fetches complete data
  React.useEffect(() => {
    if (
      (isCompactMode || isEmbeddedView) &&
      leadDetails &&
      leadDetails.leads_uuid &&
      !hasInitializedFromLeadDetails.current
    ) {
      hasInitializedFromLeadDetails.current = true;
      // Convert the single lead row data to proper format with multiple_events_list
      const initialLeadData: ILead = {
        ...leadDetails,
        // Ensure multiple_events_list has at least the current event from row data
        multiple_events_list:
          leadDetails.multiple_events_list &&
            leadDetails.multiple_events_list?.length > 0
            ? leadDetails.multiple_events_list
            : [
              {
                leads_uuid: leadDetails.leads_uuid,
                event_type: leadDetails.event_type || "",
                event_uuid: leadDetails.event_uuid || "",
                event_time: leadDetails.event_time || "",
                event_time_uuid: leadDetails.event_time_uuid || "",
                preferred_venue: leadDetails.preferred_venue || "",
                preferred_venue_uuid: leadDetails.preferred_venue_uuid || "",
                booking_date: leadDetails.booking_date || null,
                function_month: leadDetails.function_month || null,
                function_date: leadDetails.function_date || null,
                followup_date: leadDetails.followup_date || null,
                status: leadDetails.status || "ONGOING",
                actual_status: leadDetails.actual_status || "ONGOING",
                drive_status_uuid: leadDetails.drive_status_uuid || "",
                number_of_rooms: leadDetails.number_of_rooms || 0,
                number_of_guests: leadDetails.number_of_guests || 0,
                cancellation_dead_reason:
                  leadDetails.cancellation_dead_reason || null,
                payment_mode: leadDetails.payment_mode || null,
                other_event_name: leadDetails.other_event_name || null,
                estimated_rough_revenue:
                  leadDetails.estimated_rough_revenue ?? null,
                guest_budget: leadDetails.guest_budget ?? null,
                is_archived: leadDetails.is_archived || 0,
                extras: (leadDetails as any).extras ?? null,
              },
            ],
        // ...(leadDetails.handled_by_employee_uuid && {
        //   handled_by_employee_uuid: userUuid,
        //   handled_by_employee: name,
        // }),
      };
      setValues(initialLeadData);
      // Set loading state to show skeleton for additional events
      setIsLoadingMoreEvents(true);
    }
  }, [isCompactMode, isEmbeddedView, leadDetails]);

  // Fetch before Redux→form sync so FETCH_LEAD_PROGRESS clears stale `leads.lead` before setValues.
  React.useEffect(() => {
    if (leadUUID && multiEventUUID) {
      hasLoadedLeadDataRef.current = "";
      lastVenueCheckRef.current = {};
      hasInitializedFromLeadDetails.current = false;
      if (skipNextLeadFetchRef.current) {
        skipNextLeadFetchRef.current = false;
      } else {
        fetchMultiEventLeadAsync();
      }
    }

    dispatch(
      fetchDriveStatusListAsync(
        companyOutlet.comapny.company_outlet_uuid,
        isCompactMode && !!chatActionItem?.action_item_uuid
          ? [
            {
              column: ["actual_status"],
              operator: "IN",
              value: ["DEAD", "CANCELLED", "ONGOING"],
              logicalOperator: "AND",
            },
          ]
          : undefined,
      ),
    );
  }, [
    leadUUID,
    multiEventUUID,
    dispatch,
    companyOutlet.comapny.company_outlet_uuid,
    isCompactMode,
    chatActionItem?.action_item_uuid,
  ]);

  React.useEffect(() => {
    if (!leadUUID || !requestedLeadData?.leads_uuid) {
      return;
    }
    if (
      !doesFetchedLeadMatchOpenContext(
        requestedLeadData,
        leadUUID,
        multiEventUUID,
      )
    ) {
      return;
    }
    if (hasLoadedLeadDataRef.current !== requestedLeadData.leads_uuid) {
      hasLoadedLeadDataRef.current = requestedLeadData.leads_uuid;
      setValues({
        ...requestedLeadData,
      });
      setIsLoadingMoreEvents(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadUUID, multiEventUUID, requestedLeadData?.leads_uuid]);

  // Auto-select "Direct" source for new leads
  React.useEffect(() => {
    if (leadUUID || values.lead_source_uuid) return;

    const fetchAndSetDefaultSource = async () => {
      try {
        const res = await api.get(
          `/leads/get-lead-source?company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}&status=ACTIVE`,
        );
        const sources = res.data.data || [];
        const directSource = sources.find(
          (s: any) => s.source_name?.toLowerCase().includes("direct"),
        );
        if (directSource) {
          setFieldValue("lead_source_uuid", directSource.lead_source_uuid);
          setFieldValue("source", directSource.source_name);
        }
      } catch (err) {
        // silently ignore
      }
    };

    if (companyOutlet.comapny.company_outlet_uuid) {
      fetchAndSetDefaultSource();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyOutlet.comapny.company_outlet_uuid, leadUUID]);

  // show to monika for upsell lead right panel
  // React.useEffect(() => {
  //   // if (leadUUID && multiEventUUID) {
  //   if (leadUUID) {
  //     // Reset refs when switching to a different lead
  //     hasLoadedLeadDataRef.current = "";
  //     lastVenueCheckRef.current = "";
  //     hasInitializedFromLeadDetails.current = false;

  //     dispatch(
  //       fetchLeadAsync({
  //         leadId: leadUUID ?? "",
  //         multiple_events_uuid: multiEventUUID,
  //         company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
  //         skipLoader: isCompactMode ? true : false,
  //       }),
  //     );
  //   }

  //   dispatch(
  //     fetchDriveStatusListAsync(companyOutlet.comapny.company_outlet_uuid),
  //   );
  // }, [
  //   leadUUID,
  //   multiEventUUID,
  //   dispatch,
  //   companyOutlet.comapny.company_outlet_uuid,
  // ]);

  // Fetch default "ONGOING" status's drive_status_uuid for new leads
  React.useEffect(() => {
    // Only for new leads (no leadUUID) and when drive status list is loaded
    if (
      leadUUID ||
      !companyOutlet.comapny.company_outlet_uuid ||
      driveStatusLoading !== LoadState.Loaded ||
      driveStatusList.length === 0
    ) {
      return;
    }

    const statuses: IMasterStatus[] = driveStatusList;

    // Find the default ONGOING status (lowest status_unique_id)
    const ongoingStatus = getLowestOngoingStatus(statuses);

    // Use status_uuid as drive_status_uuid (API returns status_uuid, not drive_status_uuid)
    const driveStatusUuid =
      ongoingStatus?.drive_status_uuid || ongoingStatus?.status_uuid;

    if (driveStatusUuid) {
      // Update the main lead's drive_status_uuid
      setFieldValue("drive_status_uuid", driveStatusUuid);

      // Also update any events in multiple_events_list that have ONGOING status
      if (values.multiple_events_list?.length > 0) {
        const updatedEvents = values.multiple_events_list.map((event) => {
          if (
            event.actual_status === "ONGOING" &&
            (!event.drive_status_uuid || event.drive_status_uuid === "")
          ) {
            return {
              ...event,
              drive_status_uuid: driveStatusUuid,
            };
          }
          return event;
        });
        setFieldValue("multiple_events_list", updatedEvents);
      }
    }
  }, [
    leadUUID,
    companyOutlet.comapny.company_outlet_uuid,
    driveStatusLoading,
    driveStatusList,
  ]);

  const prevEventsRef = React.useRef<any[] | null>(null);

  // A lead was created from the quotation tab — reload the enquiry so the form
  // (and the quotation rows built from it) pick up the new event.
  const handleQuotationEventLeadsCreated = () => {
    hasLoadedLeadDataRef.current = "";
    lastVenueCheckRef.current = {};
    // Re-baseline availability on the reloaded events instead of re-checking them all
    prevEventsRef.current = null;
    fetchMultiEventLeadAsync();
  };

  React.useEffect(() => {
    const events = values.multiple_events_list;
    if (!events?.length) return;

    // First run — capture baseline
    if (!prevEventsRef.current) {
      prevEventsRef.current = structuredClone(events);
      return;
    }

    // List length changed (event added/removed) — re-baseline with empty venue fields
    // for new events so the next diff detects them
    if (prevEventsRef.current.length !== events.length) {
      const newBaseline = events.map((event, i) => {
        if (i < prevEventsRef.current!.length) {
          return prevEventsRef.current![i]; // existing event keeps its prev
        }
        // New event — set prev availability fields to empty so diff fires on next render
        return { ...event, preferred_venue_uuid: "", function_date: "", event_time_uuid: "", actual_status: "" };
      });
      prevEventsRef.current = newBaseline;
      return;
    }

    events.forEach((event, i) => {
      const prev = prevEventsRef.current![i];
      if (!prev) return;

      const key = getAvailabilityCheckKey(event, prev);
      if (!key) return;

      lastVenueCheckRef.current[i] = key;
      dispatch(
        fetchVenueAvailabilityAsync(
          event.preferred_venue_uuid,
          event.event_time_uuid,
          event.function_date as string,
          (_ok, data) => {
            setVenueAvailabilityMap((m) => ({
              ...m,
              [i]: { checked: true, availabilty: data?.availabilty ?? null, details: data ?? null },
            }));
          },
        ),
      );
    });

    prevEventsRef.current = structuredClone(events);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(values.multiple_events_list)]);

  React.useEffect(() => {
    if (isCompactMode && onCompactModeSaveClick) {
      // Create a global reference to the save handler
      (window as any).leadSaveHandler = () => {
        // Use Formik's validateForm to check all validations
        validateForm().then((formErrors) => {
          // If there are any validation errors, mark submit as attempted
          if (Object.keys(formErrors).length > 0) {
            setSubmitAttempted(true);
            setShowError(formErrors);

            if ((window as any).showLeadErrors) {
              (window as any).showLeadErrors(formErrors);
            }
            return;
          }

          // If validation passes, proceed with the save
          if (leadUUID) {
            setPreviewBeforeSave(values);
          } else {
            handleSubmit();
          }
        });
      };
    }

    if (isCompactMode && onCompactModeCancellationClick) {
      // Create a global reference to the cancellation handler
      (window as any).leadCancellationHandler = () => {
        setOpenCancellation(true);
        // Note: Since we don't have clickedEventLeadUuid in compact mode for single event
        // We'll use the first event's leadUUID
        if (
          values.multiple_events_list &&
          values.multiple_events_list.length > 0
        ) {
          setClickedEventLeadUuid(
            values.multiple_events_list[0].leads_uuid || "",
          );
        }
      };
    }

    if (isCompactMode && onCompactModeSaveNoAdvanceClick) {
      // Create a global reference to the save no advance handler
      (window as any).leadSaveNoAdvanceHandler = () => {
        // Use Formik's validateForm to check all validations
        validateForm().then((formErrors) => {
          // If there are any validation errors, mark submit as attempted
          if (Object.keys(formErrors).length > 0) {
            setSubmitAttempted(true);
            setShowError(formErrors);

            if ((window as any).showLeadErrors) {
              (window as any).showLeadErrors(formErrors);
            }
            return;
          }

          if (leadUUID) {
            setIsNoAdvanceSave(true);
            setPreviewBeforeSave(values);
          } else {
            handleSubmit();
          }
        });
      };
    }

    return () => {
      // Cleanup global references
      if (isCompactMode) {
        delete (window as any).leadSaveHandler;
        delete (window as any).leadCancellationHandler;
        delete (window as any).leadSaveNoAdvanceHandler;
      }
    };
  }, [
    isCompactMode,
    onCompactModeSaveClick,
    onCompactModeCancellationClick,
    onCompactModeSaveNoAdvanceClick,
    values,
    leadUUID,
    handleSubmit,
    validateForm,
  ]);

  React.useEffect(() => {
    props.onShouldShowNoAdvanceSaveChange?.(shouldShowNoAdvanceSave);
  }, [shouldShowNoAdvanceSave]);

  React.useEffect(() => {
    if (
      leadUUID ||
      driveStatusLoading !== LoadState.Loaded ||
      driveStatusList.length === 0
    ) {
      return;
    }

    // Find the ONGOING status item from Redux store (lowest status_unique_id)
    const ongoingStatus = getLowestOngoingStatus(driveStatusList);

    // Only update if found
    if (ongoingStatus) {
      setFieldValue("drive_status_uuid", ongoingStatus.drive_status_uuid);
      setFieldValue("status", ongoingStatus.actual_status);
      setFieldValue("handled_by_employee", name);
      setFieldValue("handled_by_employee_uuid", userUuid || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadUUID, driveStatusLoading, driveStatusList]);

  // Set default event selection in Payment Details tab
  React.useEffect(() => {
    if (
      leadUUID &&
      values.multiple_events_list &&
      values.multiple_events_list.length > 0
    ) {
      // Find the event that matches the URL leadUUID
      const matchingEvent = values.multiple_events_list.find(
        (event) => event.leads_uuid === leadUUID,
      );

      // If found, set it as the default selection
      if (matchingEvent && paymentDetailsLeadUuid === "") {
        setPaymentDetailsLeadUuid(matchingEvent.leads_uuid || "");
      }
      // If no matching event found and paymentDetailsLeadUuid is empty, select the first event
      else if (
        !matchingEvent &&
        paymentDetailsLeadUuid === "" &&
        values.multiple_events_list.length > 0
      ) {
        setPaymentDetailsLeadUuid(
          values.multiple_events_list[0].leads_uuid || "",
        );
      }
    }
  }, [leadUUID, values.multiple_events_list, paymentDetailsLeadUuid]);

  // Reset paymentDetailsLeadUuid when leadUUID changes
  React.useEffect(() => {
    setPaymentDetailsLeadUuid("");
  }, [leadUUID]);

  const leadTabs = (
    <TabsList
      sx={{
        p: "3px",
        borderRadius: "4px",
        boxShadow: "none",
        bgcolor: "#eef1f6",
        minHeight: 0,
        "& .MuiTabs-flexContainer": { gap: "2px" },
        "& .MuiTab-root": {
          minHeight: 0,
          padding: "5px 14px",
          fontSize: "0.8rem",
          fontWeight: 600,
          textTransform: "none",
          borderRadius: "4px",
          color: "#5a6474",
          opacity: 1,
          transition: "color .15s, background .15s",
        },
        "& .MuiTab-root:hover": {
          color: "#1f2937",
        },
        "& .Mui-selected": {
          background: "#fff !important",
          color: "#1f2937 !important",
          borderRadius: "4px",
          boxShadow: "0 1px 2px rgba(16,24,40,0.16)",
        },
      }}
      varaint="standard"
      selectedTab={tab}
      tabs={[
        { label: "Lead" },
        ...(values.is_payment_transaction_exist === 1 &&
          accessibleModuleIds.includes(ALLOWED_MODULES.PAYMENT_TRANSACTION)
          ? [{ label: "Update Estimate Flow" }]
          : [{ label: "Quotation" }]),
        ...(accessibleModuleIds.includes(ALLOWED_MODULES.PAYMENT_TRANSACTION)
          ? [{ label: "Payment Details" }]
          : []),
      ]}
      onChange={handleTabChange}
    />
  );

  return (
    <>
      {showBreadcrumbBar && (
        <BreadcrumbBar
          sticky
          navigation={BCrumb}
          title={leadBreadcrumbTitle}
          centerContent={leadUUID ? leadTabs : undefined}
          rightContent={
            leadUUID && tab === 0 ? (
              <Button
                variant="outlined"
                size="small"
                startIcon={<Insights fontSize="small" />}
                onClick={() => setShowActivityRoot(!showActivityRoot)}
                sx={{
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  fontSize: "0.8rem",
                  py: "4px",
                  px: 1.5,
                }}
              >
                {showActivityRoot ? "Close Activity" : "Show Activity"}
              </Button>
            ) : undefined
          }
          onHeightChange={setBreadcrumbHeight}
        />
      )}

      <PageContainer
        title={leadUUID ? "Edit Lead" : "Create New Lead"}
        description="this is inner page"
      >
        <Grid container spacing={1}>
          <Grid item xs={12} md={!showActivityRoot || tab !== 0 ? 12 : (leadUUID || chatActionItem) ? 8.5 : 12}>
            {isCompactMode ? (
              <form onSubmit={handleSubmit}>
                <Box>
                  <StandardCard
                    hideHeadingDivider
                  // Compact mode's Activity toggle is rendered by the host
                  // RightPanel header (see EditLeadDetails) via showActivity.
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4} lg={isFormNarrow ? 4 : 2}>
                        <CustomTextField
                          label={"Guest Name *"}
                          name="name_of_guest"
                          value={values.name_of_guest}
                          fullWidth
                          disabled={disableFormByStatus}
                          onChange={handleChange}
                          error={
                            submitAttempted && errors.name_of_guest
                              ? true
                              : false
                          }
                          helperText={
                            submitAttempted ? errors.name_of_guest : ""
                          }
                        />
                      </Grid>

                      <Grid item xs={4} sm={4} md={2} lg={isFormNarrow ? 2 : 1.2} sx={{ minWidth: "110px" }}>
                        <CountryCodeSelector
                          label={"Country Code"}
                          sx={{
                            minHeight: 36,
                          }}
                          value={values.country_iso_code}
                          onChange={(country) => {
                            setValues((prev) => ({
                              ...prev,
                              country_code: country.dialCode,
                              country_iso_code: country.code,
                            }))
                          }}
                          error={submitAttempted && errors.country_code ? errors.country_code : undefined}
                        />

                      </Grid>
                      <Grid item xs={8} sm={8} md={4} lg={isFormNarrow ? 3 : 2}>
                        <PhoneTextField
                          label="Primary Contact Number *"
                          name="contact_number_one"
                          value={values.contact_number_one}
                          disabled={disableFormByStatus}
                          fullWidth
                          onChange={handlePhoneTextFieldChange(
                            "contact_number_one",
                          )}
                          error={
                            submitAttempted && errors.contact_number_one
                              ? true
                              : false
                          }
                          helperText={
                            submitAttempted ? errors.contact_number_one : ""
                          }
                          InputProps={{
                            endAdornment: values.contact_number_one ? (
                              <InputAdornment position="end">
                                {renderCallButton(values.contact_number_one, values.country_code)}
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyPhoneNumber(
                                      values.contact_number_one,
                                      values.country_code,
                                    );
                                  }}
                                  disabled={disableFormByStatus}
                                  edge="end"
                                  title="Copy phone number"
                                >
                                  <ContentCopy fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ) : undefined,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={isFormNarrow ? 3 : 2}>
                        <CustomDatePicker
                          placeholder="Enquiry Date"
                          key="date_of_visit"
                          value={values.date_of_visit}
                          onChange={(newDate) => {
                            setFieldValue("date_of_visit", newDate);
                          }}
                          fullWidth
                          disabled={disableFormByStatus}
                          errorMessage={submitAttempted ? errors.date_of_visit : undefined}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={isFormNarrow ? 4 : 2.4}>
                        <UsersAutoSearch
                          label="Handled By Employee"
                          showTopLabel={false}
                          value={{
                            user_uuid:
                              values.handled_by_employee_uuid as string,
                            user_name: values.handled_by_employee as string,
                          }}
                          disabled={disableFormByStatus}
                          onSelect={(newValue: any) => {
                            setValues((prevValues) => ({
                              ...prevValues,
                              handled_by_employee_uuid: newValue.user_uuid,
                              handled_by_employee: `${newValue.first_name} ${newValue.last_name || ""
                                }`.trim(),
                            }));
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={isFormNarrow ? 4 : 2.4}>
                        <ControlledCustomSelect
                          fullWidth
                          name="priority"
                          label="Priority"
                          disabled={disableFormByStatus}
                          value={values.priority}
                          onChange={(e) => {
                            setFieldValue("priority", e.target.value);
                            if (isCompactMode && chatActionItem?.action_item_uuid) {
                              setChatLeadPriority(e.target.value as any);
                            }
                          }}
                          options={[
                            { label: "Cold", value: "COLD" },
                            { label: "Hot", value: "HOT" },
                          ]}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={isFormNarrow ? 4 : 2.4}>
                        <LeadSourceAutoSearch
                          label="Source"
                          value={{
                            lead_source_uuid: values.lead_source_uuid,
                            source: values.source,
                          }}
                          source_name={values.source || ""}
                          disabled={disableFormByStatus}
                          onSelect={(newValue: any) => {
                            setFieldValue(
                              "lead_source_uuid",
                              newValue.lead_source_uuid ?? "",
                            );
                            setFieldValue("source", newValue.source_name ?? "");
                          }}
                          hideAddButton={false}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={isFormNarrow ? 4 : 2.4}>
                        <CustomEmailField
                          label="Email"
                          name="email"
                          value={values.email}
                          disabled={disableFormByStatus}
                          onChange={handleChange}
                          fullWidth
                          error={submitAttempted && errors.email ? true : false}
                          helperText={submitAttempted ? errors.email : ""}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={8}
                        lg={isFormNarrow ? 8 : 9.6}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        {!showDescriptionField && (
                          <IconButton
                            onClick={() =>
                              setShowDescriptionField(!showDescriptionField)
                            }
                          >
                            {values.description ? <Edit /> : <Add />}
                          </IconButton>
                        )}

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          {!showDescriptionField ? (
                            <Button
                              onClick={() =>
                                setShowDescriptionField(!showDescriptionField)
                              }
                            >
                              <Typography sx={{ fontWeight: 600 }}>
                                {values.description
                                  ? values.description
                                  : "Add Description"}
                              </Typography>
                            </Button>
                          ) : (
                            <CustomTextField
                              label="Description"
                              multiline
                              minRows={3}
                              name="description"
                              value={values.description}
                              fullWidth
                              sx={{ flex: 1, width: "100%" }}
                              disabled={isDescriptionDisabled}
                              onChange={handleChange}
                              onBlur={() => setShowDescriptionField(false)}
                              autoFocus
                              error={
                                submitAttempted && errors.description
                                  ? true
                                  : false
                              }
                              helperText={
                                submitAttempted ? errors.description : ""
                              }
                            />
                          )}
                        </Box>
                      </Grid>

                      {/* <Grid item xs={12} lg={12}>
                        <CustomTextField
                          label="Description"
                          multiline
                          minRows={3}
                          name="description"
                          value={values.description}
                          fullWidth
                          disabled={isLoadingMoreEvents}
                          onChange={handleChange}
                          error={
                            submitAttempted && errors.description ? true : false
                          }
                          helperText={submitAttempted ? errors.description : ""}
                        />
                      </Grid> */}
                    </Grid>
                  </StandardCard>

                  <StandardCard
                    sx={{ mt: 2, overflow: "hidden" }}
                    heading={"Event Details"}
                  >
                    <EventDetailsManager
                      events={(values.multiple_events_list || []).map(
                        (event) => {
                          const showMonthPicker =
                            "show_month_picker" in event
                              ? event.show_month_picker
                              : !event.function_date && !!event.function_month;

                          return {
                            ...event,
                            show_month_picker: Boolean(showMonthPicker),
                          };
                        },
                      )}
                      initialEvents={
                        requestedLeadData?.multiple_events_list || []
                      }
                      onEventsChange={(updatedEvents) => {
                        const hasDead = updatedEvents.some(
                          (e) =>
                            (e.actual_status || "").toUpperCase() === "DEAD" ||
                            (e.status || "").toUpperCase() === "DEAD",
                        );
                        const syncedEvents = updatedEvents.map((event) => {
                          const isDead =
                            (event.actual_status || "").toUpperCase() === "DEAD" ||
                            (event.status || "").toUpperCase() === "DEAD";
                          return {
                            ...event,
                            followup_date: isDead ? null : (event.followup_date || values.followup_date),
                          };
                        });
                        setFieldValue("multiple_events_list", syncedEvents);
                        if (hasDead) {
                          setFieldValue("followup_date", null);
                        }
                      }}
                      errors={errors}
                      submitAttempted={submitAttempted}
                      companyOutletUuid={
                        companyOutlet.comapny.company_outlet_uuid
                      }
                      isEventDisabled={isEventDisabled}
                      disableFormByStatus={disableFormByStatus}
                      onPaymentClick={(leadUuid) => {
                        setClickedEventLeadUuid(leadUuid);
                        // setPreviewBeforeSave(values);
                        setOpenPaymentTransaction(true);
                      }}
                      onCancellationClick={(leadUuid) => {
                        setOpenCancellation(true);
                        setClickedEventLeadUuid(leadUuid);
                      }}
                      onBookedOrReleaseClick={(leadUuid, btnType) => {
                        handleBookedStatusClick(leadUuid, btnType);
                      }}
                      loading={loading}
                      onDeleteEventClick={(eventLeadUuid, onSuccess) => {
                        handleDeleteEventLead(eventLeadUuid, onSuccess);
                      }}
                      isLoadingMoreEvents={isLoadingMoreEvents}
                      // isVenueAvailable={
                      //   isVenueAvailable.checked
                      //     ? isVenueAvailable.availabilty
                      //     : undefined
                      // }
                      eventAvailabilityMap={venueAvailabilityMap}
                      leadData={values}
                      driveStatusAdvancedFilters={
                        isCompactMode && !!chatActionItem?.action_item_uuid
                          ? [
                            {
                              column: ["actual_status"],
                              operator: "IN",
                              value: ["DEAD", "CANCELLED", "ONGOING"],
                              logicalOperator: "AND",
                            },
                          ]
                          : undefined
                      }
                    />
                  </StandardCard>

                  <StandardCard
                    heading="Follow-up Details"
                    sx={{ marginTop: 2 }}
                  >
                    <Grid container spacing={2}>
                      {!isDeadStatus && (
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <CustomDatePicker
                            placeholder="Followup Date"
                            fullWidth
                            minDate={moment()}
                            value={values.followup_date || ""}
                            disabled={isLoadingMoreEvents}
                            onChange={(newValue) =>
                              handleFollowupDateChange(newValue)
                            }
                            errorMessage={followupDateErrorMessage}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} lg={12}>
                        <CustomTextField
                          label="Remark *"
                          multiline
                          minRows={3}
                          name="remarks"
                          disabled={isLoadingMoreEvents}
                          value={values.remarks}
                          fullWidth
                          onChange={handleChange}
                          error={
                            submitAttempted && errors.remarks ? true : false
                          }
                          helperText={submitAttempted ? errors.remarks : ""}
                        />
                      </Grid>
                    </Grid>
                  </StandardCard>

                  <StandardCard
                    heading="Additional Details"
                    sx={{ marginTop: 2, mb: 2 }}
                    onHeaderClick={() =>
                      setShowOptionalDetails((prev) => !prev)
                    }
                    rightHeading={
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowOptionalDetails((prev) => !prev);
                        }}
                      >
                        {showOptionalDetails ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    }
                  >
                    <Collapse
                      in={showOptionalDetails}
                      timeout="auto"
                      unmountOnExit
                    >
                      {/* Additional Contact Numbers */}
                      <Box>
                        {/* Mobile Card View */}
                        {isMobile ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            {(values.additional_contact_number || []).map(
                              (contact, index) => (
                                <Paper
                                  key={index}
                                  elevation={3}
                                  sx={{
                                    p: 2,
                                    borderRadius: 3,
                                    cursor: "pointer",
                                    transition:
                                      "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    background:
                                      "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                                    border: "1px solid",
                                    borderColor: "divider",
                                    "&:hover": {
                                      transform: "translateY(-4px)",
                                      boxShadow: 6,
                                      borderColor: "primary.main",
                                    },
                                    "&:active": {
                                      transform: "translateY(-2px)",
                                    },
                                  }}
                                  onClick={() => {
                                    setEditingContactIndex(index);
                                    setContactEditDialogOpen(true);
                                  }}
                                >
                                  {/* Card Header */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                      mb: 2,
                                    }}
                                  >
                                    <Box sx={{ flex: 1 }}>
                                      <Typography
                                        variant="subtitle1"
                                        fontWeight="600"
                                        color="primary.main"
                                        sx={{ mb: 0.5 }}
                                      >
                                        Contact #{index + 1}
                                      </Typography>
                                    </Box>

                                    {/* Action Buttons */}
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        // disabled={disableFormByStatus}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const newContact: IAdditionalContactNumber =
                                          {
                                            country_code: country.dialCode,
                                            country_iso_code: country.code,
                                            contact_number: "",
                                            name: "",
                                            relation_with_customer: "",
                                          };
                                          setFieldValue(
                                            "additional_contact_number",
                                            [
                                              ...(values.additional_contact_number ||
                                                []),
                                              newContact,
                                            ],
                                          );
                                        }}
                                        sx={{
                                          backgroundColor: alpha(
                                            theme.palette.primary.main,
                                            0.1,
                                          ),
                                          "&:hover": {
                                            backgroundColor: alpha(
                                              theme.palette.primary.main,
                                              0.2,
                                            ),
                                          },
                                        }}
                                      >
                                        <AddIcon fontSize="small" />
                                      </IconButton>

                                      <IconButton
                                        color="error"
                                        size="small"
                                        // disabled={disableFormByStatus}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const updatedContacts = (
                                            values.additional_contact_number ||
                                            []
                                          ).filter((_, i) => i !== index);
                                          setFieldValue(
                                            "additional_contact_number",
                                            updatedContacts,
                                          );
                                        }}
                                        sx={{
                                          backgroundColor: alpha(
                                            theme.palette.error.main,
                                            0.1,
                                          ),
                                          "&:hover": {
                                            backgroundColor: alpha(
                                              theme.palette.error.main,
                                              0.2,
                                            ),
                                          },
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Box>
                                  </Box>

                                  <Divider sx={{ my: 1.5 }} />

                                  {/* Card Content */}
                                  <Grid container spacing={1.5}>
                                    <Grid item xs={6}>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mb: 0.5 }}
                                      >
                                        Country Code
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        fontWeight="500"
                                      >
                                        {contact.country_code || "--"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mb: 0.5 }}
                                      >
                                        Additional Contact Number
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          fontWeight="500"
                                        >
                                          {contact.contact_number || "--"}
                                        </Typography>
                                        {contact.contact_number &&
                                          renderCallButton(contact.contact_number, contact.country_code)}
                                        {contact.contact_number && (
                                          <IconButton
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCopyPhoneNumber(
                                                contact.contact_number,
                                                contact.country_code,
                                              );
                                            }}
                                            // disabled={disableFormByStatus}
                                            sx={{ p: 0.5 }}
                                            title="Copy phone number"
                                          >
                                            <ContentCopy fontSize="small" />
                                          </IconButton>
                                        )}
                                      </Box>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mb: 0.5 }}
                                      >
                                        Additional Name
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        fontWeight="500"
                                      >
                                        {contact.name || "--"}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mb: 0.5 }}
                                      >
                                        Relation with Customer
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        fontWeight="500"
                                      >
                                        {contact.relation_with_customer || "--"}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              ),
                            )}

                            {/* Empty State */}
                            {(values.additional_contact_number || []).length ===
                              0 && (
                                <Paper
                                  elevation={1}
                                  sx={{
                                    p: 3,
                                    borderRadius: 3,
                                    textAlign: "center",
                                    background:
                                      "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                                    border: "1px dashed",
                                    borderColor: "divider",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    No additional contacts added. Click the "Add
                                    Contact" button to add a new contact.
                                  </Typography>

                                  <Button
                                    variant="outlined"
                                    size="small"
                                    // disabled={disableFormByStatus}
                                    onClick={() => {
                                      const newContact: IAdditionalContactNumber =
                                      {
                                        country_code: country.dialCode,
                                        country_iso_code: country.code,
                                        contact_number: "",
                                        name: "",
                                        relation_with_customer: "",
                                      };
                                      setFieldValue("additional_contact_number", [
                                        ...(values.additional_contact_number ||
                                          []),
                                        newContact,
                                      ]);
                                    }}
                                    startIcon={<AddIcon />}
                                  >
                                    Add Contact
                                  </Button>
                                </Paper>
                              )}
                          </Box>
                        ) : (
                          /* Desktop Table View */
                          <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    sx={{ fontWeight: 600, width: "100px" }}
                                  >
                                    Action
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontWeight: 600, width: "150px" }}
                                  >
                                    Country Code
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontWeight: 600, width: "250px" }}
                                  >
                                    Additional Contact Number
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontWeight: 600, width: "250px" }}
                                  >
                                    Additional Name
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontWeight: 600, width: "250px" }}
                                  >
                                    Relation with Customer
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {(values.additional_contact_number || []).map(
                                  (contact, index) => (
                                    <TableRow key={index}>
                                      <TableCell>
                                        <IconButton
                                          color="error"
                                          size="small"
                                          // disabled={disableFormByStatus}
                                          onClick={() => {
                                            const updatedContacts = (
                                              values.additional_contact_number ||
                                              []
                                            ).filter((_, i) => i !== index);
                                            setFieldValue(
                                              "additional_contact_number",
                                              updatedContacts,
                                            );
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                        <IconButton
                                          color="primary"
                                          size="small"
                                          // disabled={disableFormByStatus}
                                          onClick={() => {
                                            const newContact: IAdditionalContactNumber =
                                            {
                                              country_code: country.dialCode,
                                              country_iso_code: country.code,
                                              contact_number: "",
                                              name: "",
                                              relation_with_customer: "",
                                            };
                                            setFieldValue(
                                              "additional_contact_number",
                                              [
                                                ...(values.additional_contact_number ||
                                                  []),
                                                newContact,
                                              ],
                                            );
                                          }}
                                        >
                                          <AddIcon />
                                        </IconButton>
                                      </TableCell>
                                      <TableCell>
                                        <CountryCodeSelector
                                          sx={{
                                            minHeight: 36,
                                          }}
                                          value={contact.country_iso_code}
                                          // disabled={disableFormByStatus}
                                          onChange={(value) => {
                                            const updatedContacts = [
                                              ...(values.additional_contact_number ||
                                                []),
                                            ];
                                            updatedContacts[index] = {
                                              ...contact,
                                              country_code: value.dialCode,
                                              country_iso_code: value.code
                                            };
                                            setFieldValue(
                                              "additional_contact_number",
                                              updatedContacts,
                                            );
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <PhoneTextField
                                          label=""
                                          fullWidth
                                          name={`additional_contact_number_${index}`}
                                          value={contact.contact_number}
                                          // disabled={disableFormByStatus}
                                          onChange={(value: string) => {
                                            const updatedContacts = [
                                              ...(values.additional_contact_number ||
                                                []),
                                            ];
                                            updatedContacts[index] = {
                                              ...contact,
                                              contact_number: value,
                                            };
                                            setFieldValue(
                                              "additional_contact_number",
                                              updatedContacts,
                                            );
                                          }}
                                          InputProps={{
                                            endAdornment:
                                              contact.contact_number ? (
                                                <InputAdornment position="end">
                                                  {renderCallButton(contact.contact_number, contact.country_code)}
                                                  <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleCopyPhoneNumber(
                                                        contact.contact_number,
                                                        contact.country_code,
                                                      );
                                                    }}
                                                    // disabled={
                                                    //   disableFormByStatus
                                                    // }
                                                    edge="end"
                                                    title="Copy phone number"
                                                  >
                                                    <ContentCopy fontSize="small" />
                                                  </IconButton>
                                                </InputAdornment>
                                              ) : undefined,
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <CustomTextField
                                          label=""
                                          name={`additional_contact_number_${index}_name`}
                                          value={contact.name}
                                          fullWidth
                                          // disabled={disableFormByStatus}
                                          onChange={(
                                            e: React.ChangeEvent<
                                              | HTMLInputElement
                                              | HTMLTextAreaElement
                                            >,
                                          ) => {
                                            const updatedContacts = [
                                              ...(values.additional_contact_number ||
                                                []),
                                            ];

                                            updatedContacts[index] = {
                                              ...contact,
                                              name: e.target.value, // ✅ Extract string properly
                                            };

                                            setFieldValue(
                                              "additional_contact_number", // ✅ Correct field name
                                              updatedContacts,
                                            );
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <RelationAutoSearch
                                          label=""
                                          placeholder="Search or type relation"
                                          value={contact.relation_with_customer || ""}
                                          disabled={disableFormByStatus}
                                          onChange={(value: string) => {
                                            const updatedContacts = [
                                              ...(values.additional_contact_number ||
                                                []),
                                            ];

                                            updatedContacts[index] = {
                                              ...contact,
                                              relation_with_customer: value,
                                            };

                                            setFieldValue(
                                              "additional_contact_number",
                                              updatedContacts,
                                            );
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                                {(values.additional_contact_number || [])
                                  .length === 0 && (
                                    <TableRow>
                                      <TableCell colSpan={5} align="center">
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 1,
                                            py: 2,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            align="center"
                                          >
                                            No additional contacts added. Click
                                            the "Add Contact" button to add a new
                                            contact.
                                          </Typography>

                                          <Button
                                            variant="outlined"
                                            size="small"
                                            // disabled={disableFormByStatus}
                                            onClick={() => {
                                              const newContact: IAdditionalContactNumber =
                                              {
                                                country_code: country.dialCode,
                                                country_iso_code: country.code,
                                                contact_number: "",
                                                name: "",
                                                relation_with_customer: "",
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                [
                                                  ...(values.additional_contact_number ||
                                                    []),
                                                  newContact,
                                                ],
                                              );
                                            }}
                                            startIcon={<AddIcon />}
                                          >
                                            Add Contact
                                          </Button>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}

                        {/* Mobile Edit Dialog - Bottom to Top Animation */}
                        <Dialog
                          fullScreen
                          open={contactEditDialogOpen}
                          onClose={() => {
                            setContactEditDialogOpen(false);
                            setEditingContactIndex(null);
                          }}
                          TransitionComponent={ContactSlideTransition}
                          sx={{
                            "& .MuiDialog-paper": {
                              borderTopLeftRadius: 24,
                              borderTopRightRadius: 24,
                              maxHeight: "90vh",
                              marginTop: "10vh",
                            },
                          }}
                        >
                          {editingContactIndex !== null &&
                            values.additional_contact_number?.[
                            editingContactIndex
                            ] && (
                              <Box
                                sx={{
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  background:
                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                }}
                              >
                                {/* Dialog Header */}
                                <Box
                                  sx={{
                                    p: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.95)",
                                    backdropFilter: "blur(10px)",
                                    borderBottom: "1px solid",
                                    borderColor: "divider",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <Box>
                                    <Typography
                                      variant="h6"
                                      fontWeight="600"
                                      color="primary.main"
                                    >
                                      Edit Contact Details
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      Contact #{editingContactIndex + 1}
                                    </Typography>
                                  </Box>
                                  <IconButton
                                    onClick={() => {
                                      setContactEditDialogOpen(false);
                                      setEditingContactIndex(null);
                                    }}
                                    sx={{
                                      backgroundColor: alpha(
                                        theme.palette.error.main,
                                        0.1,
                                      ),
                                      "&:hover": {
                                        backgroundColor: alpha(
                                          theme.palette.error.main,
                                          0.2,
                                        ),
                                      },
                                    }}
                                  >
                                    <Close />
                                  </IconButton>
                                </Box>

                                {/* Dialog Content */}
                                <Box
                                  sx={{
                                    flex: 1,
                                    overflow: "auto",
                                    p: 2,
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <CountryCodeSelector
                                        label="Country Code"
                                        sx={{
                                          minHeight: 36,
                                        }}
                                        value={
                                          values.additional_contact_number[
                                            editingContactIndex
                                          ].country_iso_code
                                        }
                                        disabled={disableFormByStatus}
                                        onChange={(value) => {
                                          const updatedContacts = [
                                            ...(values.additional_contact_number ||
                                              []),
                                          ];
                                          updatedContacts[editingContactIndex] =
                                          {
                                            ...updatedContacts[
                                            editingContactIndex
                                            ],
                                            country_code: value.dialCode,
                                            country_iso_code: value.code
                                          };
                                          setFieldValue(
                                            "additional_contact_number",
                                            updatedContacts,
                                          );
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <PhoneTextField
                                        label="Contact Number"
                                        name={`additional_contact_number_${editingContactIndex}`}
                                        value={
                                          values.additional_contact_number[
                                            editingContactIndex
                                          ].contact_number
                                        }
                                        disabled={disableFormByStatus}
                                        fullWidth
                                        onChange={(value: string) => {
                                          const updatedContacts = [
                                            ...(values.additional_contact_number ||
                                              []),
                                          ];
                                          updatedContacts[editingContactIndex] =
                                          {
                                            ...updatedContacts[
                                            editingContactIndex
                                            ],
                                            contact_number: value,
                                          };
                                          setFieldValue(
                                            "additional_contact_number",
                                            updatedContacts,
                                          );
                                        }}
                                        InputProps={{
                                          endAdornment: values
                                            .additional_contact_number[
                                            editingContactIndex
                                          ].contact_number ? (
                                            <InputAdornment position="end">
                                              {renderCallButton(
                                                values.additional_contact_number[editingContactIndex].contact_number,
                                                values.additional_contact_number[editingContactIndex].country_code,
                                              )}
                                              <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleCopyPhoneNumber(
                                                    values
                                                      .additional_contact_number[
                                                      editingContactIndex
                                                    ].contact_number,
                                                    values
                                                      .additional_contact_number[
                                                      editingContactIndex
                                                    ].country_code,
                                                  );
                                                }}
                                                disabled={disableFormByStatus}
                                                edge="end"
                                                title="Copy phone number"
                                              >
                                                <ContentCopy fontSize="small" />
                                              </IconButton>
                                            </InputAdornment>
                                          ) : undefined,
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <CustomTextField
                                        label="Additional Name"
                                        name={`additional_contact_number_${editingContactIndex}_name`}
                                        value={
                                          values.additional_contact_number[
                                            editingContactIndex
                                          ].name || ""
                                        }
                                        disabled={disableFormByStatus}
                                        fullWidth
                                        onChange={(
                                          e: React.ChangeEvent<
                                            | HTMLInputElement
                                            | HTMLTextAreaElement
                                          >,
                                        ) => {
                                          const updatedContacts = [
                                            ...(values.additional_contact_number ||
                                              []),
                                          ];
                                          updatedContacts[editingContactIndex] = {
                                            ...updatedContacts[
                                            editingContactIndex
                                            ],
                                            name: e.target.value,
                                          };
                                          setFieldValue(
                                            "additional_contact_number",
                                            updatedContacts,
                                          );
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <RelationAutoSearch
                                        label="Relation with Customer"
                                        value={
                                          values.additional_contact_number[
                                            editingContactIndex
                                          ].relation_with_customer || ""
                                        }
                                        disabled={disableFormByStatus}
                                        onChange={(value: string) => {
                                          const updatedContacts = [
                                            ...(values.additional_contact_number ||
                                              []),
                                          ];
                                          updatedContacts[editingContactIndex] = {
                                            ...updatedContacts[
                                            editingContactIndex
                                            ],
                                            relation_with_customer: value,
                                          };
                                          setFieldValue(
                                            "additional_contact_number",
                                            updatedContacts,
                                          );
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Box>

                                {/* Dialog Footer with Save Button */}
                                <Box
                                  sx={{
                                    p: 2,
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.95)",
                                    backdropFilter: "blur(10px)",
                                    borderTop: "1px solid",
                                    borderColor: "divider",
                                    boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <Button
                                    fullWidth
                                    variant="contained"
                                    disabled={
                                      disableFormByStatus ||
                                      (leadUUID &&
                                        requestedLeadData?.multiple_events_list?.some(
                                          (item) =>
                                            ["BOOKED", "DEAD"].includes(
                                              item.actual_status as string,
                                            ),
                                        )) ||
                                      values?.multiple_events_list?.some(
                                        (item) =>
                                          ["BOOKED", "DEAD"].includes(
                                            item.actual_status as string,
                                          ),
                                      )
                                    }
                                    onClick={() => {
                                      setContactEditDialogOpen(false);
                                      setEditingContactIndex(null);
                                    }}
                                  >
                                    Save Changes
                                  </Button>
                                </Box>
                              </Box>
                            )}
                        </Dialog>
                      </Box>

                    </Collapse>
                  </StandardCard>

                  {/* <DynamicFormRender
                    formData={formData}
                    disableFormByStatus={disableFormByStatus}
                    payload={values.extras || null}
                    onChange={(extraData) => {
                      setFieldValue("extras", extraData);
                    }}
                    onValidationChange={(isValid, errors) => {
                      setIsDynamicFormValid(isValid);
                      setDynamicFormErrors(errors);
                    }}
                    showErrors={showDynamicFormErrors}
                  /> */}
                </Box>
                {!isCompactMode && shouldShowNoAdvanceSave && (
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    marginTop={2}
                    marginBottom={2}
                    justifyContent={{ xs: "stretch", sm: "right" }}
                    sx={{ flexWrap: "wrap" }}
                  >
                    <RoleBasedCustomButton
                      moduleId={ALLOWED_MODULES.USERS}
                      type="button"
                      onClick={() => {
                        if (leadUUID) {
                          setIsNoAdvanceSave(true);
                        }
                        handleGlobalSaveClick();
                      }}
                      variant="contained"
                      sx={{
                        paddingX: 4,
                        borderRadius: 2,
                        backgroundColor: "primary",
                      }}
                      // disabled={
                      //   isVenueAvailable.checked &&
                      //   !isVenueAvailable.availabilty
                      // }
                      disabled={
                        // Check if any event has availability checked and unavailable
                        Object.values(venueAvailabilityMap).some(
                          (availability) =>
                            availability.checked && !availability.availabilty,
                        )
                      }
                    >
                      Save (No Advance)
                    </RoleBasedCustomButton>
                  </Stack>
                )}
              </form>
            ) : (
              <>
                <TabPanel value={tab} index={0}>
                  <form onSubmit={handleSubmit}>
                    <Box>
                      <StandardCard
                        heading={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              p: 0,
                              m: 0,
                            }}
                          >
                            {leadUUID ? "Edit Lead" : "Create Lead"}

                            {/* <LeadStatusRenderer
                              status={values.actual_status || ""}
                              actualStatus={values.actual_status || ""}
                            /> */}
                          </Box>
                        }
                        rightHeading={
                          // "Show Activity" moved up into the BreadcrumbBar's
                          // rightContent; "Boost Your Plan" is disabled.
                          undefined
                        }
                      >
                        <Grid container spacing={2} mt={1}>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <CustomTextField
                              highlight={isMobile}
                              label={"Guest Name *"}
                              name="name_of_guest"
                              value={values.name_of_guest}
                              fullWidth
                              // disabled={disableFormByStatus}
                              onChange={handleChange}
                              error={
                                submitAttempted && errors.name_of_guest
                                  ? true
                                  : false
                              }
                              helperText={
                                submitAttempted ? errors.name_of_guest : ""
                              }
                            />
                          </Grid>

                          <Grid item xs={12} sm={4} md={2} lg={1.2} sx={{ minWidth: "110px" }}>
                            <CountryCodeSelector
                              label={"Country Code"}
                              sx={{
                                minHeight: 36,
                              }}
                              value={values.country_iso_code}
                              onChange={(newCountry) => {
                                setValues((prev) => ({
                                  ...prev,
                                  country_code: newCountry.dialCode,
                                  country_iso_code: newCountry.code,
                                }))
                              }}
                              error={submitAttempted && errors.country_code ? errors.country_code : undefined}
                            />
                            {/* <CountryOLDCodeSelect
                              label={"Country Code"}
                              value={values.country_code}
                              // disabled={disableFormByStatus}
                              onChange={(value) =>
                                setFieldValue("country_code", value)
                              }
                              error={
                                submitAttempted && errors.country_code
                                  ? true
                                  : false
                              }
                              helperText={
                                submitAttempted ? errors.country_code : ""
                              }
                            /> */}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <PhoneTextField
                              highlight={isMobile}
                              label="Primary Contact Number *"
                              name="contact_number_one"
                              value={values.contact_number_one}
                              onChange={(value) => {
                                setFieldValue("contact_number_one", value);
                              }}
                              // disabled={disableFormByStatus}
                              fullWidth
                              error={
                                submitAttempted && errors.contact_number_one
                                  ? true
                                  : false
                              }
                              helperText={
                                submitAttempted ? errors.contact_number_one : ""
                              }
                              InputProps={{
                                endAdornment: values.contact_number_one ? (
                                  <InputAdornment position="end">
                                    {renderCallButton(values.contact_number_one, values.country_code)}
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCopyPhoneNumber(
                                          values.contact_number_one,
                                          values.country_code,
                                        );
                                      }}
                                      disabled={disableFormByStatus}
                                      edge="end"
                                      title="Copy phone number"
                                    >
                                      <ContentCopy fontSize="small" />
                                    </IconButton>
                                  </InputAdornment>
                                ) : undefined,
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <CustomDatePicker
                              placeholder="Enquiry Date"
                              key="date_of_visit"
                              value={values.date_of_visit}
                              onChange={(newDate) => {
                                setFieldValue("date_of_visit", newDate);
                              }}
                              fullWidth
                              // disabled={disableFormByStatus}
                              errorMessage={submitAttempted ? errors.date_of_visit : undefined}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={2.4}>
                            <UsersAutoSearch
                              label="Handled By Employee"
                              showTopLabel={false}
                              value={{
                                user_uuid:
                                  values.handled_by_employee_uuid as string,
                                user_name: values.handled_by_employee as string,
                              }}
                              // disabled={disableFormByStatus}
                              onSelect={(newValue: any) => {
                                setValues((prevValues) => ({
                                  ...prevValues,
                                  handled_by_employee_uuid: newValue.user_uuid,
                                  handled_by_employee: `${newValue.first_name
                                    } ${newValue.last_name || ""}`.trim(),
                                }));
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2.4}>
                            <ControlledCustomSelect
                              fullWidth
                              name="priority"
                              label="Priority"
                              // disabled={disableFormByStatus}
                              value={values.priority}
                              onChange={(e) => {
                                setFieldValue("priority", e.target.value);
                              }}
                              options={[
                                { label: "Cold", value: "COLD" },
                                { label: "Hot", value: "HOT" },
                              ]}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <LeadSourceAutoSearch
                              label="Source"
                              value={{
                                lead_source_uuid: values.lead_source_uuid,
                                source: values.source,
                              }}
                              source_name={values.source || ""}
                              // disabled={disableFormByStatus}
                              onSelect={(newValue: any) => {
                                setFieldValue(
                                  "lead_source_uuid",
                                  newValue.lead_source_uuid ?? "",
                                );
                                setFieldValue(
                                  "source",
                                  newValue.source_name ?? "",
                                );
                              }}
                              hideAddButton={false}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <CustomEmailField
                              label="Email"
                              name="email"
                              value={values.email}
                              onChange={handleChange}
                              fullWidth
                              error={
                                submitAttempted && errors.email ? true : false
                              }
                              helperText={submitAttempted ? errors.email : ""}
                            />
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            lg={8}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            {!showDescriptionField && (
                              <IconButton
                                onClick={() =>
                                  setShowDescriptionField(!showDescriptionField)
                                }
                              >
                                {values.description ? <Edit /> : <Add />}
                              </IconButton>
                            )}

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: showDescriptionField ? "100%" : "98%",
                              }}
                            >
                              {!showDescriptionField ? (
                                <Button
                                  onClick={() =>
                                    setShowDescriptionField(
                                      !showDescriptionField,
                                    )
                                  }
                                >
                                  <Typography sx={{ fontWeight: 600 }}>
                                    {values.description
                                      ? values.description
                                      : "Add Description/Requirments"}
                                  </Typography>
                                </Button>
                              ) : (
                                <CustomTextField
                                  label="Description"
                                  multiline
                                  minRows={3}
                                  name="description"
                                  value={values.description}
                                  fullWidth
                                  disabled={isDescriptionDisabled}
                                  onChange={handleChange}
                                  onBlur={() => setShowDescriptionField(false)}
                                  autoFocus
                                  error={
                                    submitAttempted && errors.description
                                      ? true
                                      : false
                                  }
                                  helperText={
                                    submitAttempted ? errors.description : ""
                                  }
                                />
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </StandardCard>

                      <Box
                        sx={{
                          mt: 1, borderRadius: 2.4,
                          background: "#fff"
                        }}
                      >
                        <Typography
                          variant="h2"
                          fontSize={{
                            xs: "0.75rem",
                            sm: "0.9rem",
                            md: "1.1rem",
                            lg: "1.2rem",
                          }}
                          fontWeight={"700"}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flex: 1,
                            minWidth: 0,
                            padding: 1.5
                          }}
                        >
                          Event Details
                        </Typography>

                        <EventDetailsManager
                          events={values.multiple_events_list || []}
                          initialEvents={
                            requestedLeadData?.multiple_events_list || []
                          }
                          onEventsChange={(updatedEvents) => {
                            const hasDead = updatedEvents.some(
                              (e) =>
                                (e.actual_status || "").toUpperCase() === "DEAD" ||
                                (e.status || "").toUpperCase() === "DEAD",
                            );
                            const syncedEvents = updatedEvents.map((event) => {
                              const isDead =
                                (event.actual_status || "").toUpperCase() === "DEAD" ||
                                (event.status || "").toUpperCase() === "DEAD";
                              return {
                                ...event,
                                followup_date: isDead ? null : (event.followup_date || values.followup_date),
                              };
                            });
                            setFieldValue(
                              "multiple_events_list",
                              syncedEvents,
                            );
                            if (hasDead) {
                              setFieldValue("followup_date", null);
                            }
                          }}
                          errors={errors}
                          submitAttempted={submitAttempted}
                          companyOutletUuid={
                            companyOutlet.comapny.company_outlet_uuid
                          }
                          isEventDisabled={isEventDisabled}
                          disableFormByStatus={disableFormByStatus}
                          onPaymentClick={(leadUuid) => {
                            setClickedEventLeadUuid(leadUuid);
                            // setPreviewBeforeSave(values);
                            setOpenPaymentTransaction(true);
                          }}
                          onCancellationClick={(leadUuid) => {
                            setOpenCancellation(true);
                            setClickedEventLeadUuid(leadUuid);
                          }}
                          onBookedOrReleaseClick={(leadUuid, btnType) => {
                            handleBookedStatusClick(leadUuid, btnType);
                          }}
                          loading={loading || bookedStatusLoading}
                          onDeleteEventClick={(eventLeadUuid, onSuccess) => {
                            handleDeleteEventLead(eventLeadUuid, onSuccess);
                          }}
                          isLoadingMoreEvents={isLoadingMoreEvents}
                          // isVenueAvailable={
                          //   isVenueAvailable.checked
                          //     ? isVenueAvailable.availabilty
                          //     : undefined
                          // }
                          eventAvailabilityMap={venueAvailabilityMap}
                          leadData={values}
                        />
                      </Box>

                      <StandardCard
                        heading="Follow-up Details"
                        sx={{ marginTop: 1 }}
                      >
                        <Grid container spacing={2}>
                          {!isDeadStatus && (
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                              <CustomDatePicker
                                placeholder="Followup Date"
                                fullWidth
                                minDate={moment()}
                                value={values.followup_date || ""}
                                disabled={isLoadingMoreEvents}
                                onChange={(newValue) =>
                                  handleFollowupDateChange(newValue)
                                }
                                errorMessage={followupDateErrorMessage}
                              />
                            </Grid>
                          )}
                          <Grid item xs={12} lg={12}>
                            <CustomTextField
                              highlight={isMobile}
                              label="Remark *"
                              multiline
                              minRows={3}
                              name="remarks"
                              value={values.remarks}
                              fullWidth
                              disabled={isLoadingMoreEvents}
                              onChange={handleChange}
                              error={
                                submitAttempted && errors.remarks ? true : false
                              }
                              helperText={submitAttempted ? errors.remarks : ""}
                            />
                          </Grid>
                        </Grid>
                      </StandardCard>

                      <StandardCard
                        heading="Additional Details"
                        sx={{ marginTop: 1, mb: 2 }}
                        onHeaderClick={() =>
                          setShowOptionalDetails((prev) => !prev)
                        }
                        rightHeading={
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowOptionalDetails((prev) => !prev);
                            }}
                          >
                            {showOptionalDetails ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        }
                      >
                        <Collapse
                          in={showOptionalDetails}
                          timeout="auto"
                          unmountOnExit
                        >
                          {/* Additional Contact Numbers */}
                          <Box>
                            {/* Mobile Card View */}
                            {isMobile ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                }}
                              >
                                {(values.additional_contact_number || []).map(
                                  (contact, index) => (
                                    <Paper
                                      key={index}
                                      elevation={3}
                                      sx={{
                                        p: 2,
                                        borderRadius: 3,
                                        cursor: "pointer",
                                        transition:
                                          "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                        background:
                                          "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                                        border: "1px solid",
                                        borderColor: "divider",
                                        "&:hover": {
                                          transform: "translateY(-4px)",
                                          boxShadow: 6,
                                          borderColor: "primary.main",
                                        },
                                        "&:active": {
                                          transform: "translateY(-2px)",
                                        },
                                      }}
                                      onClick={() => {
                                        setEditingContactIndex(index);
                                        setContactEditDialogOpen(true);
                                      }}
                                    >
                                      {/* Card Header */}
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "flex-start",
                                          mb: 2,
                                        }}
                                      >
                                        <Box sx={{ flex: 1 }}>
                                          <Typography
                                            variant="subtitle1"
                                            fontWeight="600"
                                            color="primary.main"
                                            sx={{ mb: 0.5 }}
                                          >
                                            Contact #{index + 1}
                                          </Typography>
                                        </Box>

                                        {/* Action Buttons */}
                                        <Box sx={{ display: "flex", gap: 1 }}>
                                          <IconButton
                                            color="primary"
                                            size="small"
                                            // disabled={disableFormByStatus}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              const newContact: IAdditionalContactNumber =
                                              {
                                                country_code: country.dialCode,
                                                country_iso_code: country.code,
                                                contact_number: "",
                                                name: "",
                                                relation_with_customer: "",
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                [
                                                  ...(values.additional_contact_number ||
                                                    []),
                                                  newContact,
                                                ],
                                              );
                                            }}
                                            sx={{
                                              backgroundColor: alpha(
                                                theme.palette.primary.main,
                                                0.1,
                                              ),
                                              "&:hover": {
                                                backgroundColor: alpha(
                                                  theme.palette.primary.main,
                                                  0.2,
                                                ),
                                              },
                                            }}
                                          >
                                            <AddIcon fontSize="small" />
                                          </IconButton>

                                          <IconButton
                                            color="error"
                                            size="small"
                                            // disabled={disableFormByStatus}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              const updatedContacts = (
                                                values.additional_contact_number ||
                                                []
                                              ).filter((_, i) => i !== index);
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                            sx={{
                                              backgroundColor: alpha(
                                                theme.palette.error.main,
                                                0.1,
                                              ),
                                              "&:hover": {
                                                backgroundColor: alpha(
                                                  theme.palette.error.main,
                                                  0.2,
                                                ),
                                              },
                                            }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </Box>
                                      </Box>

                                      <Divider sx={{ my: 1.5 }} />

                                      {/* Card Content */}
                                      <Grid container spacing={1.5}>
                                        <Grid item xs={6}>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: "block", mb: 0.5 }}
                                          >
                                            Country Code
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="500"
                                          >
                                            {contact.country_code || "--"}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: "block", mb: 0.5 }}
                                          >
                                            Additional Contact Number
                                          </Typography>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              fontWeight="500"
                                            >
                                              {contact.contact_number || "--"}
                                            </Typography>
                                            {contact.contact_number &&
                                              renderCallButton(contact.contact_number, contact.country_code)}
                                            {contact.contact_number && (
                                              <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleCopyPhoneNumber(
                                                    contact.contact_number,
                                                    contact.country_code,
                                                  );
                                                }}
                                                // disabled={disableFormByStatus}
                                                sx={{ p: 0.5 }}
                                                title="Copy phone number"
                                              >
                                                <ContentCopy fontSize="small" />
                                              </IconButton>
                                            )}
                                          </Box>
                                        </Grid>

                                        <Grid item xs={6}>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: "block", mb: 0.5 }}
                                          >
                                            Additional Name
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="500"
                                          >
                                            {contact.name || "--"}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={6}>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ display: "block", mb: 0.5 }}
                                          >
                                            Relation with Customer
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="500"
                                          >
                                            {contact.relation_with_customer || "--"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Paper>
                                  ),
                                )}

                                {/* Empty State */}
                                {(values.additional_contact_number || [])
                                  .length === 0 && (
                                    <Paper
                                      elevation={1}
                                      sx={{
                                        p: 3,
                                        borderRadius: 3,
                                        textAlign: "center",
                                        background:
                                          "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                                        border: "1px dashed",
                                        borderColor: "divider",
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        No additional contacts added. Click the
                                        "Add Contact" button to add a new contact.
                                      </Typography>

                                      <Button
                                        variant="outlined"
                                        size="small"
                                        // disabled={disableFormByStatus}
                                        onClick={() => {
                                          const newContact: IAdditionalContactNumber =
                                          {
                                            country_code: country.dialCode,
                                            country_iso_code: country.code,
                                            contact_number: "",
                                            name: "",
                                            relation_with_customer: "",
                                          };
                                          setFieldValue(
                                            "additional_contact_number",
                                            [
                                              ...(values.additional_contact_number ||
                                                []),
                                              newContact,
                                            ],
                                          );
                                        }}
                                        sx={{ mt: 2 }}
                                        startIcon={<AddIcon />}
                                      >
                                        Add Contact
                                      </Button>
                                    </Paper>
                                  )}
                              </Box>
                            ) : (
                              /* Desktop Table View */
                              <TableContainer
                                component={Paper}
                                variant="outlined"
                              >
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        sx={{ fontWeight: 600, width: "100px" }}
                                      >
                                        Action
                                      </TableCell>
                                      <TableCell
                                        sx={{ fontWeight: 600, width: "150px" }}
                                      >
                                        Country Code
                                      </TableCell>
                                      <TableCell
                                        sx={{ fontWeight: 600, width: "200px" }}
                                      >
                                        Additional Contact Number
                                      </TableCell>
                                      <TableCell
                                        sx={{ fontWeight: 600, width: "200px" }}
                                      >
                                        Additional Name
                                      </TableCell>
                                      <TableCell
                                        sx={{ fontWeight: 600, width: "250px" }}
                                      >
                                        Relation with Customer
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {(
                                      values.additional_contact_number || []
                                    ).map((contact, index) => (
                                      <TableRow key={index}>
                                        <TableCell>
                                          <IconButton
                                            color="error"
                                            size="small"
                                            // disabled={disableFormByStatus}
                                            onClick={() => {
                                              const updatedContacts = (
                                                values.additional_contact_number ||
                                                []
                                              ).filter((_, i) => i !== index);
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                          <IconButton
                                            color="primary"
                                            size="small"
                                            // disabled={disableFormByStatus}
                                            onClick={() => {
                                              const newContact: IAdditionalContactNumber =
                                              {
                                                country_code: country.dialCode,
                                                country_iso_code: country.code,
                                                contact_number: "",
                                                name: "",
                                                relation_with_customer: "",
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                [
                                                  ...(values.additional_contact_number ||
                                                    []),
                                                  newContact,
                                                ],
                                              );
                                            }}
                                          >
                                            <AddIcon />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>
                                          <CountryCodeSelector
                                            sx={{
                                              minHeight: 36,
                                            }}
                                            value={contact.country_iso_code}
                                            onChange={(newCountry) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];
                                              updatedContacts[index] = {
                                                ...contact,
                                                country_code: newCountry.dialCode,
                                                country_iso_code: newCountry.code
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <PhoneTextField
                                            label=""
                                            name={`additional_contact_number_${index}`}
                                            value={contact.contact_number}
                                            // disabled={disableFormByStatus}
                                            fullWidth
                                            onChange={(value: string) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];
                                              updatedContacts[index] = {
                                                ...contact,
                                                contact_number: value,
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                            InputProps={{
                                              endAdornment:
                                                contact.contact_number ? (
                                                  <InputAdornment position="end">
                                                    {renderCallButton(contact.contact_number, contact.country_code)}
                                                    <IconButton
                                                      size="small"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleCopyPhoneNumber(
                                                          contact.contact_number,
                                                          contact.country_code,
                                                        );
                                                      }}
                                                      disabled={
                                                        disableFormByStatus
                                                      }
                                                      edge="end"
                                                      title="Copy phone number"
                                                    >
                                                      <ContentCopy fontSize="small" />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ) : undefined,
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <CustomTextField
                                            label=""
                                            name={`additional_contact_number_${index}_name`}
                                            value={contact.name}
                                            fullWidth
                                            // disabled={disableFormByStatus}
                                            onChange={(
                                              e: React.ChangeEvent<
                                                | HTMLInputElement
                                                | HTMLTextAreaElement
                                              >,
                                            ) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];

                                              updatedContacts[index] = {
                                                ...contact,
                                                name: e.target.value, // ✅ Extract string properly
                                              };

                                              setFieldValue(
                                                "additional_contact_number", // ✅ Correct field name
                                                updatedContacts,
                                              );
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <RelationAutoSearch
                                            label=""
                                            value={
                                              contact.relation_with_customer ||
                                              ""
                                            }
                                            // disabled={disableFormByStatus}
                                            onChange={(value: string) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];

                                              updatedContacts[index] = {
                                                ...contact,
                                                relation_with_customer: value,
                                              };

                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                    {(values.additional_contact_number || [])
                                      .length === 0 && (
                                        <TableRow>
                                          <TableCell colSpan={5} align="center">
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 1,
                                                py: 2,
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                align="center"
                                              >
                                                No additional contacts added.
                                                Click the "Add Contact" button to
                                                add a new contact.
                                              </Typography>

                                              <Button
                                                variant="outlined"
                                                size="small"
                                                // disabled={disableFormByStatus}
                                                onClick={() => {
                                                  const newContact: IAdditionalContactNumber =
                                                  {
                                                    country_code: country.dialCode,
                                                    country_iso_code: country.code,
                                                    contact_number: "",
                                                    name: "",
                                                    relation_with_customer: "",
                                                  };
                                                  setFieldValue(
                                                    "additional_contact_number",
                                                    [
                                                      ...(values.additional_contact_number ||
                                                        []),
                                                      newContact,
                                                    ],
                                                  );
                                                }}
                                                startIcon={<AddIcon />}
                                              >
                                                Add Contact
                                              </Button>
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                      )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            )}

                            {/* Mobile Edit Dialog - Bottom to Top Animation */}
                            <Dialog
                              fullScreen
                              open={contactEditDialogOpen}
                              onClose={() => {
                                setContactEditDialogOpen(false);
                                setEditingContactIndex(null);
                              }}
                              TransitionComponent={ContactSlideTransition}
                              sx={{
                                "& .MuiDialog-paper": {
                                  borderTopLeftRadius: 24,
                                  borderTopRightRadius: 24,
                                  maxHeight: "90vh",
                                  marginTop: "10vh",
                                },
                              }}
                            >
                              {editingContactIndex !== null &&
                                values.additional_contact_number?.[
                                editingContactIndex
                                ] && (
                                  <Box
                                    sx={{
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      background:
                                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    }}
                                  >
                                    {/* Dialog Header */}
                                    <Box
                                      sx={{
                                        p: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        backgroundColor:
                                          "rgba(255, 255, 255, 0.95)",
                                        backdropFilter: "blur(10px)",
                                        borderBottom: "1px solid",
                                        borderColor: "divider",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      <Box>
                                        <Typography
                                          variant="h6"
                                          fontWeight="600"
                                          color="primary.main"
                                        >
                                          Edit Contact Details
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                        >
                                          Contact #{editingContactIndex + 1}
                                        </Typography>
                                      </Box>
                                      <IconButton
                                        onClick={() => {
                                          setContactEditDialogOpen(false);
                                          setEditingContactIndex(null);
                                        }}
                                        sx={{
                                          backgroundColor: alpha(
                                            theme.palette.error.main,
                                            0.1,
                                          ),
                                          "&:hover": {
                                            backgroundColor: alpha(
                                              theme.palette.error.main,
                                              0.2,
                                            ),
                                          },
                                        }}
                                      >
                                        <Close />
                                      </IconButton>
                                    </Box>

                                    {/* Dialog Content */}
                                    <Box
                                      sx={{
                                        flex: 1,
                                        overflow: "auto",
                                        p: 2,
                                        backgroundColor: "#f8f9fa",
                                      }}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <CountryCodeSelector
                                            label="Country Code"
                                            sx={{
                                              minHeight: 36,
                                            }}
                                            disabled={disableFormByStatus}
                                            value={
                                              values.additional_contact_number[
                                                editingContactIndex
                                              ].country_iso_code
                                            }
                                            onChange={(newCountry) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number || []),
                                              ];
                                              updatedContacts[editingContactIndex] = {
                                                ...updatedContacts[editingContactIndex],
                                                country_code: newCountry.dialCode,
                                                country_iso_code: newCountry.code
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={12}>
                                          <PhoneTextField
                                            label="Contact Number"
                                            name={`additional_contact_number_${editingContactIndex}`}
                                            value={
                                              values.additional_contact_number[
                                                editingContactIndex
                                              ].contact_number
                                            }
                                            disabled={disableFormByStatus}
                                            fullWidth
                                            onChange={(value: string) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];
                                              updatedContacts[
                                                editingContactIndex
                                              ] = {
                                                ...updatedContacts[
                                                editingContactIndex
                                                ],
                                                contact_number: value,
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                            InputProps={{
                                              endAdornment: values
                                                .additional_contact_number[
                                                editingContactIndex
                                              ].contact_number ? (
                                                <InputAdornment position="end">
                                                  {renderCallButton(
                                                    values.additional_contact_number[editingContactIndex].contact_number,
                                                    values.additional_contact_number[editingContactIndex].country_code,
                                                  )}
                                                  <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleCopyPhoneNumber(
                                                        values
                                                          .additional_contact_number[
                                                          editingContactIndex
                                                        ].contact_number,
                                                        values
                                                          .additional_contact_number[
                                                          editingContactIndex
                                                        ].country_code,
                                                      );
                                                    }}
                                                    disabled={
                                                      disableFormByStatus
                                                    }
                                                    edge="end"
                                                    title="Copy phone number"
                                                  >
                                                    <ContentCopy fontSize="small" />
                                                  </IconButton>
                                                </InputAdornment>
                                              ) : undefined,
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={12}>
                                          <CustomTextField
                                            label="Additional Name"
                                            name={`additional_contact_number_${editingContactIndex}_name`}
                                            value={
                                              values.additional_contact_number[
                                                editingContactIndex
                                              ].name || ""
                                            }
                                            disabled={disableFormByStatus}
                                            fullWidth
                                            onChange={(
                                              e: React.ChangeEvent<
                                                | HTMLInputElement
                                                | HTMLTextAreaElement
                                              >,
                                            ) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];
                                              updatedContacts[editingContactIndex] = {
                                                ...updatedContacts[
                                                editingContactIndex
                                                ],
                                                name: e.target.value,
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={12}>
                                          <RelationAutoSearch
                                            label="Relation with Customer"
                                            value={
                                              values.additional_contact_number[
                                                editingContactIndex
                                              ].relation_with_customer || ""
                                            }
                                            disabled={disableFormByStatus}
                                            onChange={(value: string) => {
                                              const updatedContacts = [
                                                ...(values.additional_contact_number ||
                                                  []),
                                              ];
                                              updatedContacts[editingContactIndex] = {
                                                ...updatedContacts[
                                                editingContactIndex
                                                ],
                                                relation_with_customer: value,
                                              };
                                              setFieldValue(
                                                "additional_contact_number",
                                                updatedContacts,
                                              );
                                            }}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Box>

                                    {/* Dialog Footer with Save Button */}
                                    <Box
                                      sx={{
                                        p: 2,
                                        backgroundColor:
                                          "rgba(255, 255, 255, 0.95)",
                                        backdropFilter: "blur(10px)",
                                        borderTop: "1px solid",
                                        borderColor: "divider",
                                        boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        disabled={
                                          disableFormByStatus ||
                                          (leadUUID &&
                                            requestedLeadData?.multiple_events_list?.some(
                                              (item) =>
                                                ["BOOKED", "DEAD"].includes(
                                                  item.actual_status as string,
                                                ),
                                            )) ||
                                          values?.multiple_events_list?.some(
                                            (item) =>
                                              ["BOOKED", "DEAD"].includes(
                                                item.actual_status as string,
                                              ),
                                          )
                                        }
                                        onClick={() => {
                                          setContactEditDialogOpen(false);
                                          setEditingContactIndex(null);
                                        }}
                                      >
                                        Save Changes
                                      </Button>
                                    </Box>
                                  </Box>
                                )}
                            </Dialog>
                          </Box>

                        </Collapse>
                      </StandardCard>

                      {/* <DynamicFormRender
                        formData={formData}
                        disableFormByStatus={disableFormByStatus}
                        payload={values.extras || null}
                        onChange={(extraData) => {
                          setFieldValue("extras", extraData);
                        }}
                        onValidationChange={(isValid, errors) => {
                          setIsDynamicFormValid(isValid);
                          setDynamicFormErrors(errors);
                        }}
                        showErrors={showDynamicFormErrors}
                      /> */}
                    </Box>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={2}
                      marginTop={2}
                      marginBottom={2}
                      justifyContent={{ xs: "stretch", sm: "right" }}
                      sx={{ flexWrap: "wrap" }}
                    >
                      {shouldShowNoAdvanceSave && (
                        <RoleBasedCustomButton
                          moduleId={ALLOWED_MODULES.USERS}
                          type="button"
                          // disabled={Object.keys(errors).length > 0}
                          onClick={async () => {
                            const formErrors = await validateForm();
                            setSubmitAttempted(true);
                            if (Object.keys(formErrors).length > 0) {
                              setShowError(formErrors);
                              return;
                            }
                            if (leadUUID) {
                              setIsNoAdvanceSave(true);
                              setPreviewBeforeSave(values);
                            } else {
                              handleSubmit();
                            }
                          }}
                          variant="contained"
                          sx={{
                            paddingX: 4,
                            borderRadius: 2,
                            backgroundColor: "primary",
                          }}
                          // disabled={
                          //   isVenueAvailable.checked &&
                          //   !isVenueAvailable.availabilty
                          // }
                          disabled={
                            // Check if any event has availability checked and unavailable
                            Object.values(venueAvailabilityMap).some(
                              (availability) =>
                                availability.checked &&
                                !availability.availabilty,
                            )
                          }
                        >
                          Save(No Advance)
                        </RoleBasedCustomButton>
                      )}
                      <RoleBasedCustomButton
                        moduleId={ALLOWED_MODULES.USERS}
                        type="button"
                        onClick={async () => {
                          const formErrors = await validateForm();
                          setSubmitAttempted(true);
                          if (Object.keys(formErrors).length > 0) {
                            setShowError(formErrors);
                            return;
                          }
                          if (leadUUID) {
                            setIsNoAdvanceSave(false);
                            setPreviewBeforeSave(values);
                          } else {
                            handleSubmit();
                          }
                        }}
                        variant="contained"
                        sx={{
                          paddingX: 4,
                          borderRadius: 2,
                          backgroundColor: "primary",
                        }}
                        // disabled={
                        //   isVenueAvailable.checked &&
                        //   !isVenueAvailable.availabilty
                        // }
                        disabled={
                          // Check if any event has availability checked and unavailable
                          Object.values(venueAvailabilityMap).some(
                            (availability) =>
                              availability.checked && !availability.availabilty,
                          )
                        }
                      >
                        Save
                      </RoleBasedCustomButton>
                    </Stack>
                  </form>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  {leadUUID && (
                    <ManageRoughEstimate
                      leadUUID={leadUUID}
                      showActivityRoot={showActivityRoot}
                      initialLeadToRoughEstimate={requestedLeadData}
                      eventLeadsOptions={eventOptionsForPaymentDetails}
                      onEventLeadsCreated={handleQuotationEventLeadsCreated}
                    />
                  )}
                </TabPanel>
                <TabPanel value={tab} index={2}>
                  <LeadPaymentDetailsList
                    leadUUID={leadUUID as string}
                    multipleEventsUUID={
                      multiEventUUID ||
                      requestedLeadData?.multiple_events_uuid ||
                      ""
                    }
                    initialLeadToRoughEstimate={requestedLeadData}
                    selectedEventLeadInfo={values?.multiple_events_list || []}
                  />
                </TabPanel>
              </>
            )}
          </Grid>

          {showActivityRoot && tab === 0 && (leadUUID || chatActionItem) && (
            <Grid item xs={12} md={3.5} ref={activityRef}>
              <Box
                sx={{
                  position: { xs: "static", md: "sticky" },
                  top: { xs: "auto", md: `${activityTop}px` },
                  zIndex: 10,
                  height: {
                    xs: "auto",
                    md: `calc(100vh - ${activityTop + BOTTOM_GAP}px)`,
                  },
                  maxHeight: {
                    xs: "none",
                    md: `calc(100vh - ${activityTop + BOTTOM_GAP}px)`,
                  },
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {leadUUID ? (
                  <ActivityRoot
                    onClose={() => setShowActivityRoot(false)}
                    moduleInformation={{
                      moduleId: leadUUID,
                      moduleName: MODULE_NAMES.LEADS,
                      subModuleName: MODULE_NAMES.LEADS,
                      refColumnName: "leads_uuid",
                    }}
                    activity={{
                      task: true,

                      whatsAppChat: {
                        phone: values.country_code
                          ? values.country_code +
                          requestedLeadData.contact_number_one
                          : "" + requestedLeadData.contact_number_one,

                        customerName: requestedLeadData.name_of_guest,
                      },
                      WhatsAppGroupChat: {
                        phone: values.country_code
                          ? values.country_code +
                          requestedLeadData.contact_number_one
                          : "" + requestedLeadData.contact_number_one,

                        customerName: requestedLeadData.name_of_guest,
                      },
                    }}
                  />
                ) : chatActionItem ? (
                  <ChatLeadActivityDetails
                    actionItem={chatActionItem}
                    onClose={() => setShowActivityRoot(false)}
                  />
                ) : null}
              </Box>
            </Grid>
          )}
        </Grid>
      </PageContainer>

      {openCancellation && clickedEventLeadUuid !== "" && (
        <PaymentDetailsDialog
          open={openCancellation}
          leadUUID={clickedEventLeadUuid}
          multipleEventsUUID={
            multiEventUUID || requestedLeadData?.multiple_events_uuid
          }
          onClose={handleCancellationClose}
          onComplete={(isSuccess, cancellationData) =>
            handleComplete(!!isSuccess, cancellationData)
          }
          isAdvance={isAdvance}
          isCancellation={true}
        />
      )}

      {openPaymentTransaction && clickedEventLeadUuid !== "" && (
        <PaymentDetailsDialog
          open={openPaymentTransaction}
          leadUUID={clickedEventLeadUuid}
          multipleEventsUUID={
            multiEventUUID || requestedLeadData?.multiple_events_uuid
          }
          onClose={() => {
            handlePaymentTransactionClose();
            setPendingLeadSaveAfterPayment(null);
            setIsNoAdvanceSave(false);
          }}
          onComplete={(isSuccess) => handleComplete(!!isSuccess)}
          isAdvance={isAdvance}
          isCancellation={false}
        />
      )}

      {previewBeforeSave && (
        <PreviewBeforeSaveDialog
          open={true}
          data={previewBeforeSave}
          onClose={() => {
            setPreviewBeforeSave(null);
            setIsNoAdvanceSave(false);
            setClickedEventLeadUuid("");
          }}
          onSave={() => {
            if (isNoAdvanceSave) {
              handleSubmit();
              setPreviewBeforeSave(null);
              // Note: isNoAdvanceSave is reset in onSubmit callback after async save completes
            } else {
              // Previous logic: payment if initial or current `actual_status` was BOOKED only.
              // That opened payment for BOOKED → POSTPONED because "initial" was still BOOKED.

              // const bookedEvent = previewBeforeSave?.multiple_events_list?.find(
              //   (event) => {
              //     const initialEvent =
              //       requestedLeadData?.multiple_events_list?.find(
              //         (e) => e.leads_uuid === event.leads_uuid,
              //       );
              //     const initialStatus = initialEvent?.actual_status;
              //     const currentStatus = event.actual_status;
              //     return (
              //       (initialStatus === "BOOKED" ||
              //         currentStatus === "BOOKED") &&
              //       event.leads_uuid &&
              //       event.leads_uuid !== ""
              //     );
              //   },
              // );

              // if (clickedEventLeadUuid !== "") {
              //   handleBookedStatusSave();
              // } else {
              //   if (bookedEvent) {
              //     setClickedEventLeadUuid(bookedEvent.leads_uuid || "");
              //     setPendingLeadSaveAfterPayment(previewBeforeSave);
              //     setOpenPaymentTransaction(true);
              //   } else {
              //     handleSubmit();
              //   }
              // }

              const paymentEvent = findEventForPaymentAfterSavePreview(
                previewBeforeSave,
                requestedLeadData ?? undefined,
              );
              console.log("paymentEvent ===> ", paymentEvent)
              if (paymentEvent) {
                setClickedEventLeadUuid(paymentEvent.leads_uuid || "");
                setPendingLeadSaveAfterPayment(previewBeforeSave);
                if (paymentEvent.actual_status !== "DEAD") {
                  setOpenPaymentTransaction(true);
                } else {
                  setClickedEventLeadUuid("");
                  handleSubmit();
                }
              } else {
                handleSubmit();
              }

              setPreviewBeforeSave(null);
            }
          }}
          hideMakePayment={isNoAdvanceSave}
        />
      )}

      {/* {isVenueAvailable.checked &&
        isVenueAvailable.details &&
        isVenueAvailable.availabilty === false && (
          <BookedVenueDialog
            open={true}
            onClose={() =>
              setIsVenueAvailable((prev) => ({
                ...prev,
                details: null,
              }))
            }
            BookingData={isVenueAvailable.details}
          />
        )} */}

      {Object.entries(venueAvailabilityMap).map(([index, availability]) => {
        if (
          availability.checked &&
          availability.details &&
          availability.availabilty === false
        ) {
          return (
            <BookedVenueDialog
              key={index}
              open={true}
              onClose={() => {
                setVenueAvailabilityMap((prev) => ({
                  ...prev,
                  [parseInt(index)]: {
                    ...prev[parseInt(index)],
                    details: null,
                  },
                }));
              }}
              BookingData={availability.details}
            />
          );
        }
        return null;
      })}

      <Snackbar
        open={!!showError}
        autoHideDuration={5000}
        onClose={() => setShowError(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 9999 }}
      >
        <Alert
          onClose={() => setShowError(null)}
          severity="error"
          sx={{ width: 400 }}
        >
          <List dense sx={{ p: 0 }}>
            {showError &&
              Object.values(showError).map((msg, index) => (
                <ListItem key={index} sx={{ py: 0 }}>
                  <ListItemText primary={String(msg)} />
                </ListItem>
              ))}
          </List>
        </Alert>
      </Snackbar>

      {deleteLoading && <LoadingDialog open={deleteLoading} />}

      <DialerCallDialog
        open={dialerState.open}
        type={dialerState.type}
        message={dialerState.message}
        onClose={closeDialog}
      />
    </>
  );
};
